import { registerLibrary } from '@onviobr/app-info';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _asyncToGenerator from '@babel/runtime-corejs3/helpers/asyncToGenerator';
import _classCallCheck from '@babel/runtime-corejs3/helpers/classCallCheck';
import _createClass from '@babel/runtime-corejs3/helpers/createClass';
import _get from '@babel/runtime-corejs3/helpers/get';
import _getPrototypeOf from '@babel/runtime-corejs3/helpers/getPrototypeOf';
import _inherits from '@babel/runtime-corejs3/helpers/inherits';
import _createSuper from '@babel/runtime-corejs3/helpers/createSuper';
import _taggedTemplateLiteral from '@babel/runtime-corejs3/helpers/taggedTemplateLiteral';
import _regeneratorRuntime from '@babel/runtime-corejs3/regenerator';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/es.object.to-string.js';
import 'core-js/modules/es.promise.js';
import 'core-js/modules/es.string.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import 'core-js/modules/es.symbol.js';
import 'core-js/modules/es.symbol.description.js';
import _concatInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/concat';
import _Promise from '@babel/runtime-corejs3/core-js-stable/promise';
import _JSON$stringify from '@babel/runtime-corejs3/core-js-stable/json/stringify';
import { css, i18nMixin, BlueElement, register as register$1, html, ifDefined, repeat, until } from '@onviobr/element';
import validForm from '@pageclip/valid-form';
import { not, has } from '@onviobr/services/access';
import { getSupportedLanguagesAsync, getRoute } from '@onviobr/services/environment';
import { has as has$1 } from '@onviobr/services/permission';
import { getCurrentUser, linkExistingAccountWithLogin, loginAlreadyUsedAsync, updateAccounts, getAllOnbalanceLinkedAccounts, getAllOnvioLinkedAccounts, getActiveOnbalanceLinkedAccounts, getActiveOnvioLinkedAccounts, loadPasswordRules, savePassword } from '@onviobr/services/profile/user';
import { getMeta, getBindings, store, getJWTWithUDS, switchAccountWithLongToken, createWithLinkedAccountId } from '@onviobr/services/session';
import { signSignatoryForTerms, userRequiredSignatory } from '@onviobr/services/profile/signatory';
import { addKeys, instantTranslate, changeLanguage, translate, getCurrentLanguage } from '@onviobr/services/i18n';
import { jsonHeaders, cookie } from '@onviobr/services/utils';
import { http500Thrower } from '@onviobr/services/utils/internals';
import { shadowDOMPolyfillContainingBlockFix, bmButtonStyle, bmInputStyle, alertsMixin, registerAlerts, registerModal, registerLoading, createModal, registerSelect, help, registerToggle, registerPopover, checkmark, closeX } from '@onviobr/ui-elements';
import _assertThisInitialized from '@babel/runtime-corejs3/helpers/assertThisInitialized';
import 'core-js/modules/es.regexp.exec.js';
import _objectSpread from '@babel/runtime-corejs3/helpers/objectSpread2';
import { checkPassword as checkPassword$1 } from '@onviobr/services/auth';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import _filterInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/filter';
import _toConsumableArray from '@babel/runtime-corejs3/helpers/toConsumableArray';
import _findInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/find';
import _sortInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/sort';
import { omnibus } from '@onviobr/services/utils/omnibus';
import 'core-js/modules/es.regexp.constructor.js';
import 'core-js/modules/es.regexp.to-string.js';
import _trimInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/trim';
import _URL from '@babel/runtime-corejs3/core-js-stable/url';
import { isLocalType } from '@onviobr/services/environment/constants';
import { shadowDOMPolyfillContainingBlockFix as shadowDOMPolyfillContainingBlockFix$1 } from '@onviobr/ui-elements/utils';
import 'core-js/modules/es.array.join.js';
import 'core-js/modules/es.function.name.js';
import { userRequired, getFactors, initEmergencyCodesSetup, initFactorSetup, deleteFactor } from '@onviobr/services/mfa';
import 'core-js/modules/web.dom-collections.for-each.js';
import _Object$entries from '@babel/runtime-corejs3/core-js-stable/object/entries';

var _templateObject$g, _templateObject2$f, _templateObject3$b, _templateObject4$8, _templateObject5$7, _templateObject6$4, _templateObject7$3;
var style$f = css(_templateObject$g || (_templateObject$g = _taggedTemplateLiteral(["\n  :host {\n    display: flex;\n    flex-direction: column;\n    contain: content;\n    font-size: 14px;\n  }\n\n  :host([hidden]) {\n    display: none;\n  }\n\n  :host h2 {\n    font-family: KnowledgeRegular, 'Helvetica Neue', Arial, sans-serif;\n    font-style: normal;\n    font-size: 18px;\n    color: #212121;\n  }\n\n  :host .footer {\n    border-top: solid 1px #e5e5e5;\n    padding-top: 22px;\n    padding-bottom: 22px;\n  }\n\n  :host .footer button[type='link'] {\n    background-color: #f29534;\n    color: white;\n  }\n\n  :host .footer button[type='link']:hover {\n    background-color: #f29534;\n    color: white;\n  }\n\n  :host .footer button[type='link'] a {\n    color: white;\n    text-decoration: none;\n  }\n\n  :host svg {\n    transform: scale(0.6);\n    margin-bottom: 1px;\n    /*\n      This is to override when ShadyCSS doesn't work correctly in IE11\n      TODO: Remove when all suppported browser have ShadowDOM\n    */\n    animation-name: none;\n    fill: white;\n    vertical-align: middle;\n    margin-top: -5px;\n  }\n\n  :host > form {\n    margin-bottom: 0;\n  }\n"])));
var BmSettingsPageLayout = /*#__PURE__*/function (_i18nMixin) {
  _inherits(BmSettingsPageLayout, _i18nMixin);
  var _super = _createSuper(BmSettingsPageLayout);
  function BmSettingsPageLayout() {
    var _this;
    _classCallCheck(this, BmSettingsPageLayout);
    _this = _super.call(this);
    _this.hideSave = false;
    _this.profileType = void 0;
    _this.profile = {};
    _this._onSave = _this._onSave.bind(_assertThisInitialized(_this));
    _this._onKeyup = _this._onKeyup.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(BmSettingsPageLayout, [{
    key: "_label",
    get: function get() {
      return '';
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _get(_getPrototypeOf(BmSettingsPageLayout.prototype), "connectedCallback", this).call(this);
              _context.next = 3;
              return not('Platform_DisableAuth0Phase2');
            case 3:
              if (!_context.sent) {
                _context.next = 7;
                break;
              }
              _context.t0 = 'auth0';
              _context.next = 8;
              break;
            case 7:
              _context.t0 = 'standard';
            case 8:
              this.profileType = _context.t0;
              this.hideSave = this.profileType === 'auth0';
              _context.next = 12;
              return _Promise.resolve(getCurrentUser());
            case 12:
              this.profile = _context.sent;
            case 13:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "render",
    value: function render() {
      return this.html(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteral(["\n      <form method=\"POST\" @keyup=\"", "\" @submit=\"", "\">\n        ", "\n        <slot></slot>\n        <div class=\"footer\">\n          ", "\n          ", "\n          ", "\n          <slot name=\"buttons\"></slot>\n        </div>\n      </form>\n    "])), this._onKeyup, this._onSave, this._label ? this.html(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteral(["<h2>", "</h2>"])), this._label) : null, this.hideSave ? null : this._renderSaveBtn(), this.profileType === 'auth0' ? this._renderAccountManageBtn() : null, this._renderCancelBtn(this.hideSave));
    }
  }, {
    key: "_onSave",
    value: function _onSave(event) {
      event.preventDefault();
      this.dispatchEvent(new CustomEvent('save'));
    }
  }, {
    key: "_onKeyup",
    value: function _onKeyup(event) {
      if (event.currentTarget && event.key === 'Enter') {
        event.currentTarget.dispatchEvent(new Event('submit', {
          cancelable: true,
          bubbles: true
        }));
      }
    }
  }, {
    key: "_onCancel",
    value: function _onCancel() {
      this.dispatchEvent(new CustomEvent('cancel', {
        bubbles: true,
        composed: true
      }));
    }
  }, {
    key: "_renderCancelBtn",
    value: function _renderCancelBtn(hideSave) {
      return this.html(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteral(["<button\n      type=\"button\"\n      class=\"bm-button outline primary md\"\n      data-qe-id=\"bm-button-cancel\"\n      @click=\"", "\">\n      ", "\n    </button>"])), this._onCancel.bind(this), this.i18n(hideSave ? 'common.close' : 'common.cancel'));
    }
  }, {
    key: "_renderSaveBtn",
    value: function _renderSaveBtn() {
      return this.html(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteral(["<button\n      type=\"submit\"\n      data-qe-id=\"bm-button-save\"\n      class=\"bm-button primary md\">\n      ", "\n    </button>"])), this.i18n('common.save'));
    }
  }, {
    key: "_renderAccountManageBtn",
    value: function _renderAccountManageBtn() {
      var isProdEnv = !/^(ci|demo|qed|localhost|\d+|lab\d*|qa\d*|sat\d*)\b/.test(window.location.hostname.toLowerCase());
      var auth0ProfileUrl = '';
      if (isProdEnv) {
        var _this$profile$languag;
        auth0ProfileUrl = "https://www.thomsonreuters.com/".concat((_this$profile$languag = this.profile.language) !== null && _this$profile$languag !== void 0 ? _this$profile$languag : 'en-US', "/profile");
      } else {
        var _this$profile$languag2;
        auth0ProfileUrl = "https://www-tr-com-uat-ams.ewp.thomsonreuters.com/".concat((_this$profile$languag2 = this.profile.language) !== null && _this$profile$languag2 !== void 0 ? _this$profile$languag2 : 'en-US', "/profile");
      }
      return this.html(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteral(["<button\n      type=\"link\"\n      class=\"bm-button primary md\">\n      <a href=\"", "\" target=\"_blank\">\n        ", " ", "\n      </a>\n    </button>"])), auth0ProfileUrl, this.i18n('common.trAcctManage'), this._renderOutgoingIcon());
    }
  }, {
    key: "_renderOutgoingIcon",
    value: function _renderOutgoingIcon() {
      return this.svg(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteral(["\n      <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\n        <path d=\"M8 20c0 0 1.8-6 12-6v6l12-8-12-8v6c-8 0-12 5-12 10zM22 24h-18v-12h4c0.4-0.4 0.6-0.8 1-1 1.4-1.4 3-2.4 4.8-3h-13.8v20h26v-8.4l-4 2.6v1.8z\"></path>\n      </svg>"])));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-settings-page-layout';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        label: {
          type: String,
          reflect: true,
          attribute: true
        },
        hideSave: {
          type: Boolean,
          reflect: true,
          attribute: true
        },
        profileType: {
          type: String,
          reflect: true,
          attribute: true
        },
        profile: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, bmButtonStyle, style$f];
    }
  }]);
  return BmSettingsPageLayout;
}(i18nMixin(BlueElement));
var registerPageLayout = function registerPageLayout() {
  return register$1(BmSettingsPageLayout);
};

var assigner = function assigner(ctx, prop, subProp) {
  return function (event) {
    var value = typeof event === 'string' ? event : event.target ? event.target.value : event;
    if (subProp) {
      ctx[prop] = _objectSpread(_objectSpread({}, ctx[prop]), {}, _defineProperty({}, subProp, value));
    } else {
      ctx[prop] = value;
    }
  };
};
var normalizeError = function normalizeError(error) {
  if (error.Message) {
    return Array.isArray(error.Message) ? error.Message[0] : error.Message;
  }
  if (error.Messages) {
    return Array.isArray(error.Messages) ? error.Messages[0] : error.Messages;
  }
  if (error.message) {
    return error.message;
  }
  if (error.msg) {
    return error.msg;
  }
  if (error.error) {
    return error.message;
  }
  return error;
};
function filterAsync(_x, _x2) {
  return _filterAsync.apply(this, arguments);
}
function _filterAsync() {
  _filterAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(array, fn) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", _Promise.all(_mapInstanceProperty(array).call(array, /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(item, index, list) {
              return _regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    return _context.abrupt("return", fn(item, index, list).then(function (include) {
                      return include ? item : undefined;
                    }));
                  case 1:
                  case "end":
                    return _context.stop();
                }
              }, _callee);
            }));
            return function (_x3, _x4, _x5) {
              return _ref.apply(this, arguments);
            };
          }())).then(function (items) {
            return _filterInstanceProperty(items).call(items, function (item) {
              return item !== undefined;
            });
          }));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _filterAsync.apply(this, arguments);
}

var _templateObject$f;
var formStyle = css(_templateObject$f || (_templateObject$f = _taggedTemplateLiteral(["\n  :host form {\n    margin: 0;\n    font-family: Arial, 'Helvetica Neue', sans-serif;\n    font-size: 14px;\n  }\n\n  :host form label {\n    display: flex;\n    flex-direction: column;\n    margin-right: 10px;\n    margin-bottom: 15px;\n    margin-top: 25px;\n    flex-grow: 0;\n  }\n\n  :host form label input.bm-input {\n    height: 40px;\n    padding: 6px 12px;\n    min-width: 120px;\n    box-sizing: border-box;\n  }\n\n  @media (min-width: 450px) {\n    :host form label input.bm-input.max-width {\n      max-width: 300px;\n    }\n  }\n\n  :host form label > span {\n    font-weight: 500;\n    color: #212121;\n    font-family: Arial, 'Helvetica Neue', sans-serif;\n    font-size: 1em;\n    line-height: 1.42857143;\n    margin-bottom: 5px;\n  }\n\n  :host form span strong {\n    margin-left: 30px;\n  }\n\n  :host form p {\n    margin-top: 25px;\n    margin-left: 12px;\n  }\n\n  :host form > div.sub-group {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  :host form .invalid {\n    border-color: #dc0a0a !important;\n  }\n\n  :host form input:not(output):-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  :host .validation-error {\n    font-family: KnowledgeRegular, arial, helvetica, sans-serif;\n    color: #dc0a0a;\n    padding-top: 5px;\n  }\n"])));

var enUS$6 = {
  "common.save": "Save",
  "common.requiredField": "Required Field",
  "common.cancel": "Cancel",
  "common.password": "Password",
  "common.close": "Close",
  "common.required": "required",
  "common.optional": "optional",
  "common.options": "Options",
  "common.confirm": "Confirm",
  "common.active": "Active",
  "common.inactive": "Inactive",
  "common.preview": "Preview",
  "common.manage": "Manage",
  "common.trAcctManage": "Manage Thomson Reuters account",
  "common.refresh": "Refresh"
};
var esAR$6 = {
  "common.save": "Guardar",
  "common.requiredField": "Campo requerido",
  "common.cancel": "Cancelar",
  "common.password": "Contrase\xF1a",
  "common.close": "Cerrar",
  "common.required": "requerido",
  "common.optional": "opcional",
  "common.options": "Opciones",
  "common.confirm": "Confirmar",
  "common.active": "Activo",
  "common.inactive": "Inactivo",
  "common.preview": "Vista Preliminar",
  "common.manage": "Administrar",
  "common.trAcctManage": "Administrar cuenta Thomson Reuters",
  "common.refresh": "Actualizar"
};
var ptBR$6 = {
  "common.save": "Salvar",
  "common.requiredField": "Campo obrigat\xF3rio",
  "common.cancel": "Cancelar",
  "common.password": "Senha",
  "common.close": "Fechar",
  "common.required": "obrigat\xF3rio",
  "common.optional": "opcional",
  "common.options": "Op\xE7\xF5es",
  "common.confirm": "Confirmar",
  "common.active": "Ativo",
  "common.inactive": "Inativo",
  "common.preview": "Pr\xE9-visualiza\xE7\xE3o",
  "common.manage": "Gerenciar",
  "common.trAcctManage": "Gerenciar conta Thomson Reuters",
  "common.refresh": "Atualizar"
};
var frCA$6 = {
  "common.save": "Enregistrer",
  "common.requiredField": "Champ obligatoire",
  "common.cancel": "Annuler",
  "common.password": "Mot de passe",
  "common.close": "Fermer",
  "common.required": "n\xE9cessaire",
  "common.optional": "facultatif",
  "common.options": "Options",
  "common.confirm": "Confirmer",
  "common.active": "Actif",
  "common.inactive": "Inactif",
  "common.preview": "Aper\xE7u",
  "common.manage": "G\xE9rer",
  "common.trAcctManage": "G\xE9rer le compte Thomson Reuters",
  "common.refresh": "Rafra\xEEchir"
};
var registerCommon = (function () {
  addKeys(enUS$6, 'en-US');
  addKeys(esAR$6, 'es-AR');
  addKeys(ptBR$6, 'pt-BR');
  addKeys(frCA$6, 'fr-CA');
});

var enUS$5 = {
  "password.title": "Update Password",
  "password.current": "Current Password",
  "password.new": "New Password",
  "password.confirm": "Confirm Password",
  "password.showTyping": "Show typing",
  "password.hideTyping": "Hide typing",
  "password.acceptable": "Password is acceptable",
  "password.nonAcceptable": "Please provide a valid entry for your new password.",
  "password.confirmed": "Passwords Match",
  "password.notMatch": "New password and confirm password must match",
  "password.invalidCurrentPassword": "Current password is not valid. Please try again",
  "password.success": "Your password has been successfully changed for all accounts associated with Thomson Reuters ID {{val}}",
  "password.check.title": "Confirm your password",
  "password.check.description": "Please enter the password for your account.",
  "password.validation.rulesTitle": "Password Requirements",
  "password.validation.rulesSubtitle": "Your password must include at least:",
  "password.validation.characterRule": "{{val}} characters",
  "password.validation.numberRule": "1 number (0-9)",
  "password.validation.lowerCaseRule": "1 lowercase letter (a-z)",
  "password.validation.upperCaseRule": "1 capital letter (A-Z)",
  "password.validation.specialCharactersRule": "1 supported special character",
  "password.validation.prohibitedCharacters": "Does not contain prohibited characters",
  "password.validation.blacklist": "Avoid simple passwords (for example, Password123!)",
  "password.validation.used": "Do not use previous passwords",
  "password.invalidPassword": "Unable to confirm your password. Please try again.",
  "password.capsLock": "Caps lock is on",
  "password.validation.rulesAnd": "And",
  "password.contains.personalInfo": "Please enter a valid password. Your password cannot contain personal information associated with your account."
};
var esAR$5 = {
  "password.title": "Actualizar Contrase\xF1a",
  "password.current": "Contrase\xF1a Actual",
  "password.new": "Contrase\xF1a Nueva",
  "password.confirm": "Confirmar Contrase\xF1a",
  "password.showTyping": "Mostrar caracteres",
  "password.hideTyping": "Ocultar caracteres",
  "password.acceptable": "La contrase\xF1a es aceptable",
  "password.nonAcceptable": "Proporcione una combinaci\xF3n v\xE1lida para su nueva contrase\xF1a.",
  "password.confirmed": "Las contrase\xF1as coinciden",
  "password.notMatch": "La nueva contrase\xF1a y la de confirmaci\xF3n deben coincidir",
  "password.invalidCurrentPassword": "\xA1Su contrase\xF1a actual no es v\xE1lida! Intenta de nuevo",
  "password.success": "Su contrase\xF1a se ha cambiado correctamente para todas las cuentas asociadas con Thomson Reuters ID {{val}} ",
  "password.check.title": "Confirma tu contrase\xF1a",
  "password.check.description": "Por favor indique una contrase\xF1a para su cuenta de usuario.",
  "password.validation.rulesTitle": "Requisitos para la contrase\xF1a:",
  "password.validation.rulesSubtitle": "La contrase\xF1a debe tener como m\xEDnimo:",
  "password.validation.characterRule": "{{val}} caracteres",
  "password.validation.numberRule": "1 n\xFAmero (0-9)",
  "password.validation.lowerCaseRule": "1 letra min\xFAscula (a-z)",
  "password.validation.upperCaseRule": "1 letra may\xFAscula (A-Z)",
  "password.validation.specialCharactersRule": "1 caracter especial",
  "password.validation.prohibitedCharacters": "No contiene caracteres prohibidos.",
  "password.validation.blacklist": "No utilizar contrase\xF1as simples (por ejemplo, Contrase\xF1a123!)",
  "password.validation.used": "No utilizar contrase\xF1as anteriores.",
  "password.invalidPassword": "No se puede confirmar su contrase\xF1a. Por favor, int\xE9ntelo nuevamente.",
  "password.capsLock": "May\xFAsculas activadas",
  "password.validation.rulesAnd": "Y",
  "password.contains.personalInfo": "Por favor introduzca una contrase\xF1a v\xE1lida. La contrase\xF1a no puede contener informaci\xF3n personal asociada a su cuenta."
};
var ptBR$5 = {
  "password.title": "Atualizar a senha",
  "password.current": "Senha atual",
  "password.new": "Nova senha",
  "password.confirm": "Confirme a senha",
  "password.showTyping": "Exibir digita\xE7\xE3o",
  "password.hideTyping": "Ocultar digita\xE7\xE3o",
  "password.acceptable": "A senha \xE9 aceit\xE1vel",
  "password.nonAcceptable": "Por favor, digite uma senha v\xE1lida para a sua nova senha.",
  "password.confirmed": "As senhas correspondem",
  "password.notMatch": "Os campos Nova senha e Confirme a senha devem ser iguais.",
  "password.invalidCurrentPassword": "A senha atual n\xE3o \xE9 v\xE1lida Tente novamente",
  "password.success": "Sua senha foi alterada com sucesso para todas as contas associadas ao Thomson Reuters ID {{val}}",
  "password.check.title": "Confirme sua senha",
  "password.check.description": "Por favor, digite a senha da sua conta.",
  "password.validation.rulesTitle": "Crit\xE9rios da senha",
  "password.validation.rulesSubtitle": "Sua senha deve incluir no m\xEDnimo:",
  "password.validation.characterRule": "{{val}} caracteres",
  "password.validation.numberRule": "1 n\xFAmero (0-9)",
  "password.validation.lowerCaseRule": "1 letra min\xFAscula (a-z)",
  "password.validation.upperCaseRule": "1 letra mai\xFAscula (A-Z)",
  "password.validation.specialCharactersRule": "1 caractere especial (pontua\xE7\xE3o)",
  "password.validation.prohibitedCharacters": "N\xE3o cont\xE9m caracteres proibidos",
  "password.validation.blacklist": "Evite senhas simples (por exemplo, Senha123!)",
  "password.validation.used": "N\xE3o utilize senhas anteriores",
  "password.invalidPassword": "N\xE3o foi poss\xEDvel confirmar sua senha. Por favor, tente novamente.",
  "password.capsLock": "A tecla Caps Lock est\xE1 ativada",
  "password.validation.rulesAnd": "E",
  "password.contains.personalInfo": "Por favor insira uma senha v\xE1lida. Sua senha n\xE3o pode conter informa\xE7\xF5es pessoais associados \xE0 sua conta."
};
var frCA$5 = {
  "password.title": "Mise \xE0 jour du mot de passe",
  "password.current": "Mot de passe actuel",
  "password.new": "Nouveau mot de passe",
  "password.confirm": "Confirmer le mot de passe",
  "password.showTyping": "Montrer la saisie",
  "password.hideTyping": "Cacher la saisie",
  "password.acceptable": "Le mot de passe est acceptable.",
  "password.nonAcceptable": "Veuillez fournir une saisie valide pour votre nouveau mot de passe.",
  "password.confirmed": "Les mots de passe correspondent",
  "password.notMatch": "Le nouveau mot de passe et le mot de passe de confirmation doivent correspondre.",
  "password.invalidCurrentPassword": "Le mot de passe actuel n\u2019est pas valide. Veuillez r\xE9essayer",
  "password.success": "Votre mot de passe a \xE9t\xE9 modifi\xE9 avec succ\xE8s pour tous les comptes associ\xE9s \xE0 l'identifiant de Thomson Reuters {{val}}.",
  "password.check.title": "Confirmer votre mot de passe",
  "password.check.description": "Veuillez saisir un mot de passe pour votre compte.",
  "password.validation.rulesTitle": "Exigences pour le mot de passe",
  "password.validation.rulesSubtitle": "Votre mot de passe doit inclure au moins :",
  "password.validation.characterRule": "{{val}} caract\xE8res",
  "password.validation.numberRule": "1 chiffre (0-9)",
  "password.validation.lowerCaseRule": "1 lettre minuscule (a-z)",
  "password.validation.upperCaseRule": "1 lettre majuscule (A-Z)",
  "password.validation.specialCharactersRule": "1 caract\xE8re sp\xE9cial pris en charge",
  "password.validation.prohibitedCharacters": "Ne contient pas de caract\xE8res interdits",
  "password.validation.blacklist": "\xC9vitez les mots de passe simples (par exemple, Password123!)",
  "password.validation.used": "N'utilisez pas les mots de passe pr\xE9c\xE9dents",
  "password.invalidPassword": "Impossible de confirmer votre mot de passe. Veuillez r\xE9essayer.",
  "password.capsLock": "La touche Verr. Maj. est activ\xE9e",
  "password.validation.rulesAnd": "Et",
  "password.contains.personalInfo": "Veuillez saisir un mot de passe valide. Votre mot de passe ne peut pas contenir de renseignements personnels associ\xE9s \xE0 votre compte."
};
var registerLanguage$5 = (function () {
  registerCommon();
  addKeys(enUS$5, 'en-US');
  addKeys(esAR$5, 'es-AR');
  addKeys(ptBR$5, 'pt-BR');
  addKeys(frCA$5, 'fr-CA');
});

var _templateObject$e, _templateObject2$e, _templateObject3$a;
var style$e = css(_templateObject$e || (_templateObject$e = _taggedTemplateLiteral(["\n  :host {\n    display: flex;\n    flex-direction: column;\n    contain: content;\n    font-family: Arial, 'Helvetica Neue', sans-serif;\n    font-size: 14px;\n  }\n"])));
var BmSettingsPasswordCheck = /*#__PURE__*/function (_alertsMixin) {
  _inherits(BmSettingsPasswordCheck, _alertsMixin);
  var _super = _createSuper(BmSettingsPasswordCheck);
  function BmSettingsPasswordCheck() {
    var _this;
    _classCallCheck(this, BmSettingsPasswordCheck);
    _this = _super.call(this);
    _this.password = '';
    _this.email = '';
    _this.description = 'password.check.description';
    _this.confirmLabel = 'common.confirm';
    _this.cancelLabel = 'common.cancel';
    _this.working = false;
    _this.onSubmit = _this.onSubmit.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(BmSettingsPasswordCheck, [{
    key: "updated",
    value: function updated(changedProperties) {
      _get(_getPrototypeOf(BmSettingsPasswordCheck.prototype), "updated", this).call(this, changedProperties);
      var formElement = this.shadowRoot ? this.shadowRoot.querySelector('form') : this.querySelector('form');
      if (formElement) {
        validForm(formElement, {
          errorPlacement: 'after'
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.html(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteral(["\n      <bm-alerts></bm-alerts>\n      <p>", "</p>\n      <form method=\"POST\" @submit=\"", "\">\n        <label>\n          <span>", " *</span>\n          <span>\n            <input\n              autofocus\n              class=\"bm-input max-width\"\n              required\n              @change=\"", "\"\n              type=\"password\">\n          </span>\n        </label>\n        <footer>\n          <button\n            type=\"submit\"\n            class=\"bm-button primary md\">\n              ", "\n          </button>\n          <button\n            class=\"bm-button outline primary md\"\n            @click=\"", "\">\n              ", "\n          </button>\n        </footer>\n      </form>\n      <bm-loading ?active=\"", "\"></bm-loading>\n    "])), this.i18n(this.description), this.onSubmit, this.i18n('common.password'), assigner(this, 'password'), this.i18n(this.confirmLabel), this.onCancel.bind(this), this.i18n(this.cancelLabel), this.working);
    }
  }, {
    key: "onSubmit",
    value: function () {
      var _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var formElement;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              event.stopPropagation();
              event.preventDefault();
              this.cleanAlerts();
              formElement = this.shadowRoot ? this.shadowRoot.querySelector('form') : null;
              if (!(!formElement || !formElement.checkValidity())) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return");
            case 6:
              _context.prev = 6;
              this.working = true;
              _context.next = 10;
              return checkPassword$1(this.email, this.password);
            case 10:
              if (!_context.sent) {
                _context.next = 14;
                break;
              }
              this.dispatchEvent(new CustomEvent('confirm'));
              _context.next = 15;
              break;
            case 14:
              this.replaceAlerts(instantTranslate('password.invalidPassword'), 'danger');
            case 15:
              _context.next = 20;
              break;
            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](6);
              this.replaceAlerts(normalizeError(_context.t0), 'danger');
            case 20:
              _context.prev = 20;
              this.working = false;
              return _context.finish(20);
            case 23:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[6, 17, 20, 23]]);
      }));
      function onSubmit(_x) {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }()
  }, {
    key: "onCancel",
    value: function onCancel() {
      this.dispatchEvent(new CustomEvent('cancel'));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-settings-password-check';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        confirmLabel: {
          type: String,
          attribute: true,
          reflect: true
        },
        cancelLabel: {
          type: String,
          attribute: true,
          reflect: true
        },
        description: {
          type: String,
          attribute: true,
          reflect: true
        },
        email: {
          type: String,
          attribute: true,
          reflect: true
        },
        password: {
          type: String,
          attribute: true,
          reflect: true
        },
        working: {
          type: Boolean,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, formStyle, bmButtonStyle, bmInputStyle, style$e];
    }
  }]);
  return BmSettingsPasswordCheck;
}(alertsMixin(i18nMixin(BlueElement)));
var registerPasswordCheck = function registerPasswordCheck() {
  registerLanguage$5();
  registerAlerts();
  registerModal();
  registerLoading();
  register$1(BmSettingsPasswordCheck);
};
function modalContent(opts) {
  return html(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteral(["\n    <bm-settings-password-check\n      confirmLabel=\"", "\"\n      cancelLabel=\"", "\"\n      description=\"", "\"\n      email=\"", "\"\n      @confirm=\"", "\"\n      @cancel=\"", "\"\n    ></bm-settings-password-check>\n  "])), ifDefined(opts.confirmLabel), ifDefined(opts.cancelLabel), ifDefined(opts.description), opts.email, function () {
    return opts.resolve(true);
  }, function () {
    return opts.resolve(false);
  });
}
function checkPassword(_x2) {
  return _checkPassword.apply(this, arguments);
}
function _checkPassword() {
  _checkPassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(opts) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          return _context2.abrupt("return", new _Promise(function (_resolve) {
            var _opts$title;
            var removeModal = createModal(modalContent(_objectSpread(_objectSpread({}, opts), {}, {
              resolve: function resolve(result) {
                _resolve(result);
                removeModal();
              }
            })), (_opts$title = opts.title) !== null && _opts$title !== void 0 ? _opts$title : 'password.check.title', function () {
              _resolve(false);
              return true;
            });
          }));
        case 1:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _checkPassword.apply(this, arguments);
}

var enUS$4 = {
  "linkedAccounts.title": "Linked Accounts",
  "linkedAccounts.description": "These are the accounts you can access with the login email address (Thomson Reuters ID) <strong>{{email}}</strong>",
  "linkedAccounts.description.auth0": "These are the accounts you can access with the login email address (Thomson Reuters Account) <strong>{{email}}</strong>",
  "linkedAccounts.subDescription": "To see your active accounts while working in Onvio, click your name near the top right of most screens.",
  "linkedAccounts.active.description": "This account is visible in your Linked Accounts menu.",
  "linkedAccounts.inactive.description": "You cannot access this account in your Linked Accounts menu.",
  "linkedAccounts.defaultAccount": "Default Account",
  "linkedAccounts.setDefaultAccount": "Set as Default Account",
  "linkedAccounts.defaultHelp": "Your Default Account opens when you sign in, and you can switch to an active linked account at any time.",
  "linkedAccounts.noAccounts": "No accounts were found.",
  "linkedAccounts.add": "Add linked account",
  "linkedAccount.add.title": "Linked Account Information",
  "linkedAccount.add.description": "Enter the email address and password for the account you want to link to ",
  "linkedAccount.add.email": "Email",
  "linkedAccount.add.password": "Password",
  "linkedAccount.add.alert.notEmpty": "Email and password cannot be empty",
  "linkedAccount.add.alert.wrongEmailFormat": "Please enter a valid email address.",
  "linkedAccount.add.alert.wrongCompany": "Cannot link accounts that are in the same company.",
  "linkedAccount.add.alert.accountNotFound": "Account not found. Please try again.",
  "linkedAccount.add.alert.wrongPassword": "Unable to confirm your password. Please try again.",
  "linkedAccount.add.alert.deactivatedAccount": "Deactivated account. Please contact your administrator",
  "linkedAccounts.edit.title": "Edit Linked Account",
  "linkedAccounts.edit.description": "Enter an optional nickname for the account to make it easier to identify.",
  "linkedAccounts.edit.nickname": "Account Nickname",
  "linkedAccounts.edit.popover": "Click here to create a nickname for this account.",
  "linkedAccounts.auth.emailAlreadyUsed": "Email Address In Use",
  "linkedAccounts.auth.description": "You already have an account with the  email address you entered. To use this address and link the accounts, enter the password for your existing account.",
  "linkedAccounts.auth.link": "Link Accounts",
  "linkedAccounts.auth.changeEmail": "Change Email Address",
  "linkedAccounts.auth.cannotLinkAccount": "This e-mail address (Thomson Reuters ID) it's a main user at Onvio and cannot be used for account linking."
};
var esAR$4 = {
  "linkedAccounts.title": "Cuentas Vinculadas",
  "linkedAccounts.description": "Estas son las cuentas a las que puede acceder con la direcci\xF3n de correo electr\xF3nico de inicio de sesi\xF3n (Thomson Reuters ID) <strong>{{email}}</strong> ",
  "linkedAccounts.description.auth0": "Estas son las cuentas a las que puede acceder con la direcci\xF3n de correo electr\xF3nico de inicio de sesi\xF3n (Thomson Reuters Account) <strong>{{email}}</strong> ",
  "linkedAccounts.subDescription": "Para ver sus cuentas activas mientras trabaja en Onvio, haga clic en su nombre cerca de la parte superior derecha de la mayor\xEDa de las pantallas.",
  "linkedAccounts.active.description": "Esta cuenta es visible en el men\xFA Cuentas Vinculadas.",
  "linkedAccounts.inactive.description": "No puede acceder a esta cuenta en el men\xFA Cuentas Vinculadas.",
  "linkedAccounts.defaultAccount": "Cuenta Predeterminada",
  "linkedAccounts.setDefaultAccount": "Establecer como Cuenta Predeterminada",
  "linkedAccounts.defaultHelp": "Su Cuenta Predeterminada se abre cuando inicia sesi\xF3n y puede cambiar a una cuenta vinculada activa en cualquier momento.",
  "linkedAccounts.noAccounts": "No se han encontrado cuentas.",
  "linkedAccounts.edit.title": "Editar Cuenta Vinculada",
  "linkedAccounts.edit.description": "Ingrese un apodo opcional para la cuenta para que sea m\xE1s f\xE1cil de identificar.",
  "linkedAccounts.edit.nickname": "Apodo para la Cuenta",
  "linkedAccounts.edit.popover": "Haga clic aqu\xED para crear un apodo para esta cuenta.",
  "linkedAccounts.auth.emailAlreadyUsed": "Direcci\xF3n de correo electr\xF3nico en uso",
  "linkedAccounts.auth.description": "Ya tiene una cuenta con la direcci\xF3n de correo electr\xF3nico ingresada. Para usar esta direcci\xF3n y vincular las cuentas, ingrese la contrase\xF1a de su cuenta existente.",
  "linkedAccounts.auth.link": "Vincular Cuentas",
  "linkedAccounts.auth.changeEmail": "Cambiar La Direcci\xF3n de Correo Electr\xF3nico",
  "linkedAccounts.add": "Agregar cuenta vinculada",
  "linkedAccount.add.title": "Informaci\xF3n de la cuenta vinculada",
  "linkedAccount.add.description": "Ingrese la direcci\xF3n de correo electr\xF3nico y la contrase\xF1a de la cuenta que desea vincular ",
  "linkedAccount.add.email": "Correo electr\xF3nico",
  "linkedAccount.add.password": "Contrase\xF1a",
  "linkedAccount.add.alert.notEmpty": "Los campos de correo electr\xF3nico y contrase\xF1a no pueden estar vac\xEDos",
  "linkedAccount.add.alert.wrongEmailFormat": "Escriba una direcci\xF3n de correo electr\xF3nico v\xE1lida.",
  "linkedAccount.add.alert.wrongCompany": "No se pueden vincular cuentas que est\xE1n en la misma empresa.",
  "linkedAccount.add.alert.accountNotFound": "No se ha encontrado la cuenta. Int\xE9ntelo nuevamente.",
  "linkedAccount.add.alert.wrongPassword": "No se pudo confirmar su contrase\xF1a. Int\xE9ntelo nuevamente.",
  "linkedAccount.add.alert.deactivatedAccount": "Cuenta desactivada. Por favor, comunicate con tu administrador."
};
var ptBR$4 = {
  "linkedAccounts.title": "Contas vinculadas",
  "linkedAccounts.description": "Essas s\xE3o as contas que voc\xEA pode acessar com o endere\xE7o de e-mail de login (Thomson Reuters ID) <strong>{{email}}</strong>",
  "linkedAccounts.description.auth0": "Essas s\xE3o as contas que voc\xEA pode acessar com o endere\xE7o de e-mail de login (Thomson Reuters Account) <strong>{{email}}</strong>",
  "linkedAccounts.subDescription": "Para ver suas contas ativas enquanto trabalha no Onvio, clique no seu nome no canto superior direito presente na maioria das telas.",
  "linkedAccounts.active.description": "Esta conta \xE9 vis\xEDvel no seu menu de Contas Vinculadas.",
  "linkedAccounts.inactive.description": "Voc\xEA n\xE3o pode acessar esta conta no menu de Contas Vinculadas.",
  "linkedAccounts.defaultAccount": "Conta padr\xE3o",
  "linkedAccounts.setDefaultAccount": "Definir como conta padr\xE3o",
  "linkedAccounts.defaultHelp": "Sua conta padr\xE3o \xE9 aberta quando voc\xEA faz login e voc\xEA pode alternar para uma conta vinculada ativa a qualquer momento.",
  "linkedAccounts.noAccounts": "Nenhuma conta encontrada.",
  "linkedAccounts.edit.title": "Editar conta vinculada",
  "linkedAccounts.edit.description": "Digite um apelido opcional para a conta que facilite a identifica\xE7\xE3o da mesma.",
  "linkedAccounts.edit.nickname": "Apelido da conta",
  "linkedAccounts.edit.popover": "Clique aqui para criar um apelido para esta conta.",
  "linkedAccounts.auth.emailAlreadyUsed": "Endere\xE7o de e-mail em uso",
  "linkedAccounts.auth.description": "Voc\xEA j\xE1 tem uma conta com o endere\xE7o de e-mail que voc\xEA inseriu. Para usar esse endere\xE7o e vincular as contas, insira a senha da sua conta existente.",
  "linkedAccounts.auth.link": "Vincular contas",
  "linkedAccounts.auth.changeEmail": "Mudar o endere\xE7o de e-mail",
  "linkedAccounts.auth.cannotLinkAccount": "Este endere\xE7o de e-mail (Thomson Reuters ID) trata-se de um usu\xE1rio principal do Onvio e n\xE3o poder\xE1 ser utilizado para o v\xEDnculo de contas.",
  "linkedAccounts.add": "Vincular Contas",
  "linkedAccount.add.title": "Vincular Contas",
  "linkedAccount.add.description": "Insira o endere\xE7o de e-mail e a senha da conta \xE0 qual deseja vincular ",
  "linkedAccount.add.email": "E-mail",
  "linkedAccount.add.password": "Senha",
  "linkedAccount.add.alert.notEmpty": "E-mail e senha n\xE3o podem estar vazios",
  "linkedAccount.add.alert.wrongEmailFormat": "Insira um endere\xE7o de e-mail v\xE1lido.",
  "linkedAccount.add.alert.wrongCompany": "N\xE3o \xE9 poss\xEDvel vincular contas que est\xE3o na mesma empresa.",
  "linkedAccount.add.alert.accountNotFound": "Conta n\xE3o encontrada. Por favor, tente novamente.",
  "linkedAccount.add.alert.wrongPassword": "N\xE3o foi poss\xEDvel confirmar sua senha. Por favor, tente novamente.",
  "linkedAccount.add.alert.deactivatedAccount": "Conta desativada. Entre em contato com o seu administrador."
};
var frCA$4 = {
  "linkedAccounts.title": "Comptes li\xE9s",
  "linkedAccounts.description": "Ce sont les comptes auxquels vous pouvez acc\xE9der avec l'adresse courriel de connexion (Identifiant de Thomson Reuters) <strong>{{email}}</strong> ",
  "linkedAccounts.description.auth0": "Ce sont les comptes auxquels vous pouvez acc\xE9der avec l'adresse courriel de connexion (Thomson Reuters Account) <strong>{{email}}</strong> ",
  "linkedAccounts.subDescription": "Pour voir vos comptes actifs lorsque vous travaillez dans Onvio, cliquez sur votre nom en haut \xE0 droite de la plupart des \xE9crans.",
  "linkedAccounts.active.description": "Ce compte est visible dans votre menu Comptes li\xE9s.",
  "linkedAccounts.inactive.description": "Vous ne pouvez pas acc\xE9der \xE0 ce compte dans votre menu Comptes li\xE9s.",
  "linkedAccounts.defaultAccount": "Compte par d\xE9faut",
  "linkedAccounts.setDefaultAccount": "D\xE9finir comme compte par d\xE9faut",
  "linkedAccounts.defaultHelp": "Votre compte par d\xE9faut s'ouvre lorsque vous vous connectez et vous pouvez \xE0 tout moment passer \xE0 un compte li\xE9 actif.",
  "linkedAccounts.noAccounts": "Aucun compte trouv\xE9",
  "linkedAccounts.edit.title": "Modifier le compte li\xE9",
  "linkedAccounts.edit.description": "Saisissez un pseudonyme facultatif pour le compte afin de faciliter son identification.",
  "linkedAccounts.edit.nickname": "Pseudonyme du compte",
  "linkedAccounts.edit.popover": "Cliquez ici pour cr\xE9er un pseudonyme pour ce compte.",
  "linkedAccounts.auth.emailAlreadyUsed": "Adresse courriel utilis\xE9e",
  "linkedAccounts.auth.description": "Vous avez d\xE9j\xE0 un compte avec l'adresse courriel que vous avez saisie. Pour utiliser cette adresse et lier les comptes, saisissez le mot de passe de votre compte existant.",
  "linkedAccounts.auth.link": "Lier les comptes",
  "linkedAccounts.auth.changeEmail": "Changer l'adresse courriel",
  "linkedAccounts.add": "Ajouter un compte li\xE9",
  "linkedAccount.add.title": "Renseignements sur le compte li\xE9",
  "linkedAccount.add.description": "Saisissez l'adresse courriel et le mot de passe du compte auquel vous souhaitez \xEAtre li\xE9 ",
  "linkedAccount.add.email": "Adresse courriel",
  "linkedAccount.add.password": "Mot de passe",
  "linkedAccount.add.alert.notEmpty": "Les champs pour l'adresse courriel et le mot de passe ne peuvent pas \xEAtre vides",
  "linkedAccount.add.alert.wrongEmailFormat": "Veuillez saisir une adresse courriel valide.",
  "linkedAccount.add.alert.wrongCompany": "Impossible de lier des comptes qui sont dans la m\xEAme entreprise.",
  "linkedAccount.add.alert.accountNotFound": "Compte introuvable. Veuillez r\xE9essayer.",
  "linkedAccount.add.alert.wrongPassword": "Impossible de confirmer votre mot de passe. Veuillez r\xE9essayer.",
  "linkedAccount.add.alert.deactivatedAccount": "Compte d\xE9sactiv\xE9. Veuillez communiquer avec votre administrateur."
};
var registerLanguage$4 = (function () {
  registerCommon();
  addKeys(enUS$4, 'en-US');
  addKeys(esAR$4, 'es-AR');
  addKeys(ptBR$4, 'pt-BR');
  addKeys(frCA$4, 'fr-CA');
});

function checkPasswordForAccountMerge(_x) {
  return _checkPasswordForAccountMerge.apply(this, arguments);
}
function _checkPasswordForAccountMerge() {
  _checkPasswordForAccountMerge = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(email) {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          registerLanguage$4();
          registerPasswordCheck();
          return _context.abrupt("return", checkPassword({
            email: email,
            title: 'linkedAccounts.auth.emailAlreadyUsed',
            description: 'linkedAccounts.auth.description',
            confirmLabel: 'linkedAccounts.auth.link',
            cancelLabel: 'linkedAccounts.auth.changeEmail'
          }));
        case 3:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _checkPasswordForAccountMerge.apply(this, arguments);
}

var enUS$3 = {
  "termsAndConditions.title": "Terms and Conditions",
  "termsAndConditions.label": "By clicking 'I Agree', you indicate that you agree to these Terms and Conditions.",
  "termsAndConditions.agree": "Agree",
  "termsAndConditions.disagree": "Disagree",
  "TermsAndConditions.error": "Must agree the terms and conditions"
};
var esAR$3 = {
  "termsAndConditions.title": "T\xE9rminos y Condiciones",
  "termsAndConditions.label": "Al hacer clic en 'Acepto', Usted indica que est\xE1 de acuerdo con estos T\xE9rminos y Condiciones.",
  "termsAndConditions.agree": "Acepto",
  "termsAndConditions.disagree": "No Acepto",
  "TermsAndConditions.error": "Debe aceptar los t\xE9rminos y condiciones"
};
var ptBR$3 = {
  "termsAndConditions.title": "Termos e Condi\xE7\xF5es",
  "termsAndConditions.label": "Ao clicar em 'Concordo', voc\xEA indica que concorda com estes Termos e Condi\xE7\xF5es.",
  "termsAndConditions.agree": "Concordo",
  "termsAndConditions.disagree": "Discordo",
  "TermsAndConditions.error": "Deve concordar com os termos e condi\xE7\xF5es"
};
var frCA$3 = {
  "termsAndConditions.title": "Modalit\xE9s",
  "termsAndConditions.label": "En cliquant sur 'J\u2019accepte', vous indiquez que vous acceptez ces Modalit\xE9s.",
  "termsAndConditions.agree": "Accepter",
  "termsAndConditions.disagree": "Refuser",
  "TermsAndConditions.error": "Vous devez accepter les modalit\xE9s."
};
var registerLanguage$3 = (function () {
  registerCommon();
  addKeys(enUS$3, 'en-US');
  addKeys(esAR$3, 'es-AR');
  addKeys(ptBR$3, 'pt-BR');
  addKeys(frCA$3, 'fr-CA');
});

var _templateObject$d, _templateObject2$d, _templateObject3$9, _templateObject4$7;
var style$d = css(_templateObject$d || (_templateObject$d = _taggedTemplateLiteral(["\n  :host {\n    display: flex;\n    contain: content;\n    flex-direction: column;\n    font-size: 14px;\n  }\n  :host([hidden]) {\n    display: none;\n  }\n  :host .surface {\n    width: 900px !important;\n  }\n  :host p {\n    font-family: KnowledgeRegular, arial, helvetica, sans-serif;\n    font-size: 1em;\n    line-height: 1.5;\n    margin-bottom: 20px;\n  }\n  :host .bm-container {\n    height: 400px;\n    overflow-x: hidden;\n    overflow-y: auto;\n    background-color: #fff;\n    border: 1px solid #e5e5e5;\n    margin-bottom: 20px;\n    padding: 10px;\n  }\n  :host span {\n    display: block;\n    font-weight: 700;\n    font-family: Arial, 'Helvetica Neue', sans-serif;\n    font-size: 1em;\n    color: #212121;\n    margin-bottom: 20px;\n  }\n\n  :host .new-theme.bm-container {\n    border: none;\n    height: unset;\n  }\n  :host .new-theme.bm-container ~ footer button.bm-button.primary {\n    background-color: #005da2;\n    border-color: #005da2;\n    color: #ffffff;\n  }\n  :host .new-theme.bm-container ~ footer button.bm-button.primary.outline {\n    background-color: #ffffff;\n    border-color: #737373;\n    color: #005da2;\n  }\n  :host .new-theme h1 {\n    font-weight: 600;\n  }\n  :host .new-theme h2 {\n    font-weight: 600;\n  }\n  :host :host .new-theme h3 {\n    font-weight: 600;\n  }\n  :host .new-theme h1 {\n    font-size: 24px;\n    lign-height: 28px;\n  }\n  :host .new-theme h2 {\n    font-size: 22px;\n    lign-height: 28px;\n  }\n  :host .new-theme h3 {\n    font-size: 18px;\n    lign-height: 24px;\n  }\n  :host .new-theme h4 {\n    font-size: 16px;\n    lign-height: 20px;\n  }\n  :host .new-theme h5 {\n    font-size: 14px;\n    lign-height: 20px;\n  }\n"])));
var BmSettingsTerms = /*#__PURE__*/function (_alertsMixin) {
  _inherits(BmSettingsTerms, _alertsMixin);
  var _super = _createSuper(BmSettingsTerms);
  function BmSettingsTerms() {
    var _this;
    _classCallCheck(this, BmSettingsTerms);
    _this = _super.call(this);
    _this.useNewTheme = false;
    _this.readOnly = false;
    _this.terms = void 0;
    _this.signatory = void 0;
    _this.onAgree = _this.onAgree.bind(_assertThisInitialized(_this));
    _this.onDisagree = _this.onDisagree.bind(_assertThisInitialized(_this));
    _this.onClose = _this.onClose.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(BmSettingsTerms, [{
    key: "render",
    value: function render() {
      var closed = this.readOnly || this.signatory;
      var opened = !this.readOnly && !this.signatory;
      return this.html(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteral(["\n      <bm-alerts></bm-alerts>\n      ", "\n      <span>\n        ", "\n      </span>\n      <footer>\n        ", "\n        ", "\n        ", "\n      </footer>\n      <bm-loading ?active=\"", "\"></bm-loading>\n    "])), this.terms ? this.termsContent(this.terms) : null, closed ? '' : this.i18n('termsAndConditions.label'), this._renderButton(opened, 'termsAndConditions.agree', this.onAgree), this._renderButton(opened, 'termsAndConditions.disagree', this.onDisagree, 'outline primary'), this._renderButton(closed, 'common.close', this.onClose), Boolean(!this.terms));
    }
  }, {
    key: "onAgree",
    value: function () {
      var _onAgree = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.cleanAlerts();
              _context.prev = 1;
              if (!(this.terms && !this.signatory)) {
                _context.next = 5;
                break;
              }
              _context.next = 5;
              return signSignatoryForTerms(this.terms.id);
            case 5:
              _context.next = 10;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](1);
              this.replaceAlerts(normalizeError(_context.t0), 'danger');
            case 10:
              this.dispatchEvent(new CustomEvent('agree'));
            case 11:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 7]]);
      }));
      function onAgree() {
        return _onAgree.apply(this, arguments);
      }
      return onAgree;
    }()
  }, {
    key: "onDisagree",
    value: function onDisagree() {
      this.dispatchEvent(new CustomEvent('disagree'));
    }
  }, {
    key: "onClose",
    value: function onClose() {
      this.dispatchEvent(new CustomEvent('close'));
    }
  }, {
    key: "termsContent",
    value: function termsContent(terms) {
      var termsDOM = document.createElement('div');
      termsDOM.classList.add('bm-container');
      if (this.useNewTheme) {
        termsDOM.classList.add('new-theme');
      }
      termsDOM.innerHTML = terms.text;
      return termsDOM;
    }
  }, {
    key: "_renderButton",
    value: function _renderButton(condition, text, cb) {
      var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'primary';
      if (!condition) {
        return null;
      }
      return this.html(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteral(["<button\n      class=\"bm-button ", " md\"\n      @click=\"", "\">", "\n    </button>"])), type, cb, this.i18n(text));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-settings-terms';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        readOnly: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        terms: {
          type: Object,
          attribute: false,
          reflect: false
        },
        signatory: {
          type: Object,
          attribute: false,
          reflect: false
        },
        useNewTheme: {
          type: Boolean,
          attribute: false,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, bmButtonStyle, style$d];
    }
  }]);
  return BmSettingsTerms;
}(alertsMixin(i18nMixin(BlueElement)));
var registerTerms = function registerTerms() {
  registerLanguage$3();
  registerAlerts();
  registerModal();
  registerLoading();
  register$1(BmSettingsTerms);
};
function showTermsAndConditions(_x, _x2) {
  return _showTermsAndConditions.apply(this, arguments);
}
function _showTermsAndConditions() {
  _showTermsAndConditions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(terms, signatory) {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          registerTerms();
          return _context2.abrupt("return", new _Promise(function (resolve) {
            var close = function close(result) {
              resolve(result);
              removeModal();
            };
            var removeModal = createModal(html(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteral(["\n        <bm-settings-terms\n          .terms=\"", "\"\n          .signatory=\"", "\"\n          @agree=\"", "\"\n          @disagree=\"", "\"\n          @close=\"", "\"\n        >\n        </bm-settings-terms>\n      "])), terms, signatory, function () {
              return close(true);
            }, function () {
              return close(false);
            }, function () {
              return close();
            }), 'termsAndConditions.title');
          }));
        case 2:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _showTermsAndConditions.apply(this, arguments);
}

var enUS$2 = {
  "account.title": "Account Information",
  "account.email": "Email Address",
  "account.name.first": "First Name",
  "account.name.middle": "Middle Name",
  "account.name.last": "Last Name",
  "account.language": "Language",
  "account.success": "Your account information was changed successfully.",
  "account.emailNotification": "Please check your email.  Your new email address must be verified.",
  "account.mergeSuccess": "Your account was merged successfully. Please logout and login again.",
  "account.emailUsed": "Email address is already in use. Please contact the portal administrator if you already have an account, or enter a unique email address.",
  "account.showTermsAndConditions": "View Terms and Conditions",
  "account.maxlength": "Name cannot be greater than 100 characters",
  "account.name": "Name",
  "account.refresh": "Refresh",
  "account.manageSettings": "To manage account settings like your password and two-step verification, go to Thomson Reuters Account Management.",
  "account.enterValidEmailError": "Please enter a valid email address.",
  "account.emailUserNameLengthExceededError": "Email username may not exceed 64 characters in length. (Ex.: username@gmail.com)",
  "bm.account.service.unableToLoadUser": "Unable to load user data from session."
};
var esAR$2 = {
  "account.title": "Informaci\xF3n de la Cuenta",
  "account.email": "Direcci\xF3n de correo",
  "account.name.first": "Nombre",
  "account.name.middle": "Segundo Nombre",
  "account.name.last": "Apellidos",
  "account.language": "Idioma",
  "account.success": "La informaci\xF3n de su cuenta se ha actualizado correctamente.",
  "account.mergeSuccess": "Su cuenta se vincul\xF3 con \xE9xito. Por favor cierre sesi\xF3n y vuelva a iniciar sesi\xF3n.",
  "account.emailNotification": "Su nueva direcci\xF3n de correo electr\xF3nico debe ser verificada.",
  "account.emailUsed": "La direcci\xF3n de correo electr\xF3nico ya est\xE1 en uso. P\xF3ngase en contacto con el administrador del Portal si ya tiene una cuenta o ingrese una direcci\xF3n de correo electr\xF3nico \xFAnica.",
  "account.showTermsAndConditions": "Ver T\xE9rminos y Condiciones",
  "account.maxlength": "El nombre no puede ser superior a 100 caracteres",
  "account.name": "Nombre",
  "account.refresh": "Actualizar",
  "account.manageSettings": "Para administrar la configuraci\xF3n de la cuenta, como su contrase\xF1a y la verificaci\xF3n en dos pasos, vaya al Administrador de Cuentas de Thomson Reuters.",
  "account.enterValidEmailError": "Escriba una direcci\xF3n de correo electr\xF3nico v\xE1lida.",
  "account.emailUserNameLengthExceededError": "El nombre de usuario del correo electr\xF3nico no debe exceder los 64 caracteres de longitud.(Ejemplo: nombredeusuario@gmail.com)",
  "bm.account.service.unableToLoadUser": "No se pueden cargar datos de usuario desde la sesi\xF3n."
};
var ptBR$2 = {
  "account.title": "Informa\xE7\xE3o da conta",
  "account.email": "Endere\xE7o de e-mail",
  "account.name.first": "Nome",
  "account.name.middle": "Nome do meio",
  "account.name.last": "Sobrenome",
  "account.language": "Idioma",
  "account.success": "As informa\xE7\xF5es da sua conta foram alteradas com sucesso.",
  "account.emailNotification": "Seu novo endere\xE7o de e-mail deve ser verificado.",
  "account.mergeSuccess": "Sua conta foi associada com sucesso. Por favor, fa\xE7a o logout e o login novamente.",
  "account.emailUsed": "Este endere\xE7o de e-mail j\xE1 est\xE1 em uso. Entre em contato com o administrador do portal se voc\xEA j\xE1 possui uma conta ou insira um endere\xE7o de e-mail exclusivo.",
  "account.showTermsAndConditions": "Visualizar Termos e Condi\xE7\xF5es",
  "account.maxlength": "O nome n\xE3o pode ser maior que 100 caracteres",
  "account.name": "Nome",
  "account.refresh": "Atualizar",
  "account.manageSettings": "Para gerenciar as configura\xE7\xF5es da conta, como sua senha e a verifica\xE7\xE3o em duas etapas, acesse Gerenciamento de contas da Thomson Reuters.",
  "account.enterValidEmailError": "Insira um endere\xE7o de e-mail v\xE1lido.",
  "account.emailUserNameLengthExceededError": "O nome de usu\xE1rio do email n\xE3o pode exceder 64 caracteres de comprimento. (Ex.: NomedoUsuario@gmail.com)",
  "bm.account.service.unableToLoadUser": "N\xE3o foi poss\xEDvel carregar os dados do usu\xE1rio a partir da sess\xE3o."
};
var frCA$2 = {
  "account.title": "Renseignements sur le compte",
  "account.email": "Adresse courriel",
  "account.name.first": "Pr\xE9nom",
  "account.name.middle": "Deuxi\xE8me pr\xE9nom",
  "account.name.last": "Nom de famille",
  "account.language": "Langue",
  "account.success": "Les renseignements de votre compte ont \xE9t\xE9 modifi\xE9s avec succ\xE8s.",
  "account.emailNotification": "Votre nouvelle adresse courriel doit \xEAtre v\xE9rifi\xE9e.",
  "account.mergeSuccess": "Votre compte a \xE9t\xE9 fusionn\xE9 avec succ\xE8s. Veuillez vous d\xE9connecter et vous reconnecter.",
  "account.emailUsed": "L\u2019adresse courriel est d\xE9j\xE0 utilis\xE9e. Veuillez communiquer avec l\u2019administrateur du portail si vous avez d\xE9j\xE0 un compte ou veuillez saisir une adresse courriel unique.",
  "account.showTermsAndConditions": "Afficher les modalit\xE9s",
  "account.maxlength": "Le nom ne peut pas d\xE9passer 100 caract\xE8res",
  "account.name": "Nom",
  "account.refresh": "Rafra\xEEchir",
  "account.manageSettings": "Pour g\xE9rer les param\xE8tres de compte tels que votre mot de passe et la v\xE9rification en deux \xE9tapes, acc\xE9dez \xE0 Gestion de compte Thomson Reuters.",
  "account.enterValidEmailError": "Veuillez saisir une adresse courriel valide.",
  "account.emailUserNameLengthExceededError": "Le nom d'utilisateur de courriel ne doit pas d\xE9passer 64 caract\xE8res de longueur (p. ex. : nomd'utilisateur@gmail.com)",
  "bm.account.service.unableToLoadUser": "Impossible de charger les donn\xE9es d\u2019utilisateur de la session."
};
var registerLanguage$2 = (function () {
  registerCommon();
  addKeys(enUS$2, 'en-US');
  addKeys(esAR$2, 'es-AR');
  addKeys(ptBR$2, 'pt-BR');
  addKeys(frCA$2, 'fr-CA');
});

var _templateObject$c, _templateObject2$c, _templateObject3$8, _templateObject4$6, _templateObject5$6, _templateObject6$3, _templateObject7$2, _templateObject8$2, _templateObject9$1, _templateObject10$1, _templateObject11;
var style$c = css(_templateObject$c || (_templateObject$c = _taggedTemplateLiteral(["\n  :host {\n    display: block;\n    contain: content;\n    font-size: 14px;\n  }\n  :host([hidden]) {\n    display: none;\n  }\n  :host .small-select {\n    width: 100px;\n  }\n  :host button[type='refresh-btn'] {\n    background-color: white;\n    border-color: white;\n    color: black;\n  }\n  :host .refresh-btn:hover {\n    background-color: white;\n    border-color: white;\n    opacity: 0.7;\n  }\n"])));
var BmSettingsAccountInformation = /*#__PURE__*/function (_alertsMixin) {
  _inherits(BmSettingsAccountInformation, _alertsMixin);
  var _super = _createSuper(BmSettingsAccountInformation);
  function BmSettingsAccountInformation() {
    var _context;
    var _this;
    _classCallCheck(this, BmSettingsAccountInformation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
    _this.mode = void 0;
    _this.hideLanguage = false;
    _this.hideMiddleName = false;
    _this.profileType = void 0;
    _this.working = false;
    _this.isClient = false;
    _this.hideProfileMiddleNameToBr = false;
    _this.languages = [];
    _this.profile = {};
    _this.terms = void 0;
    _this.signatory = void 0;
    _this.initialEmail = void 0;
    _this.initialLanguage = void 0;
    return _this;
  }
  _createClass(BmSettingsAccountInformation, [{
    key: "updated",
    value: function updated(changedProperties) {
      _get(_getPrototypeOf(BmSettingsAccountInformation.prototype), "updated", this).call(this, changedProperties);
      var formElement = this.shadowRoot ? this.shadowRoot.querySelector('form') : null;
      if (formElement) {
        validForm(formElement, {
          errorPlacement: 'after'
        });
      }
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, languages, user, terms, hideProfileMiddleName;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _get(_getPrototypeOf(BmSettingsAccountInformation.prototype), "connectedCallback", this).call(this);
              this.working = true;
              _context2.prev = 2;
              this.defineIfIsClient();
              _context2.next = 6;
              return _Promise.all([this.hideLanguage ? [] : getSupportedLanguagesAsync(), getCurrentUser(), userRequiredSignatory(), has('BR_HideProfileMiddleName')]);
            case 6:
              _yield$Promise$all = _context2.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 4);
              languages = _yield$Promise$all2[0];
              user = _yield$Promise$all2[1];
              terms = _yield$Promise$all2[2];
              hideProfileMiddleName = _yield$Promise$all2[3];
              this.languages = languages;
              this.terms = terms.terms;
              this.signatory = terms.signatory;
              this.hideProfileMiddleNameToBr = hideProfileMiddleName;
              this.profile = user;
              this.initialEmail = this.profile.email;
              this.initialLanguage = this.profile.language;
              _context2.next = 21;
              return not('Platform_DisableAuth0Phase2');
            case 21:
              if (!_context2.sent) {
                _context2.next = 25;
                break;
              }
              _context2.t0 = 'auth0';
              _context2.next = 26;
              break;
            case 25:
              _context2.t0 = 'standard';
            case 26:
              this.profileType = _context2.t0;
              _context2.next = 32;
              break;
            case 29:
              _context2.prev = 29;
              _context2.t1 = _context2["catch"](2);
              this.addAlert(normalizeError(_context2.t1), 'danger');
            case 32:
              _context2.prev = 32;
              this.working = false;
              return _context2.finish(32);
            case 35:
            case "end":
              return _context2.stop();
          }
        }, _callee, this, [[2, 29, 32, 35]]);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "render",
    value: function render() {
      var should = Boolean(this.isClient) && Boolean(this.terms);
      return this.html(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteral(["\n      ", "\n      <bm-settings-page-layout\n        hideSave\n        profileType=\"", "\"\n        label=\"", "\"\n        @save=\"", "\"\n        @cancel=\"", "\">\n        <bm-alerts></bm-alerts>\n        ", "\n        ", "\n      </bm-settings-page-layout>\n      <bm-loading ?active=\"", "\"></bm-loading>\n    "])), this.profileType === 'auth0' ? this._renderRefreshButton() : null, this.profileType, this.i18n('account.title'), this.onSubmit.bind(this), this.onCancel.bind(this), this.profileType === 'auth0' ? this.renderAuth0Profile(this.profile) : this.renderForm(this.profile), should ? this.renderViewTermn(this.terms, this.signatory) : null, this.working);
    }
  }, {
    key: "defineIfIsClient",
    value: function () {
      var _defineIfIsClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.mode) {
                _context3.next = 4;
                break;
              }
              this.isClient = this.mode === 'client';
              _context3.next = 7;
              break;
            case 4:
              _context3.next = 6;
              return has$1('Platform.DefaultClient');
            case 6:
              this.isClient = _context3.sent;
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee2, this);
      }));
      function defineIfIsClient() {
        return _defineIfIsClient.apply(this, arguments);
      }
      return defineIfIsClient;
    }()
  }, {
    key: "closeSuccessMessageCallback",
    value: function closeSuccessMessageCallback() {
      this.dispatchEvent(new CustomEvent('save-account', {
        bubbles: true,
        composed: true,
        detail: this.profile
      }));
    }
  }, {
    key: "onSubmit",
    value: function () {
      var _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this$profile$email, _this$profile$languag, form, emailAlreadyUsed, allowMerge, _this$profile$email2, merge, _this$profile$email3, mergeResult, hasNotification, shouldDisplayAlert;
        return _regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.cleanAlerts();
              this.working = true;
              _context4.prev = 2;
              form = this.shadowRoot ? this.shadowRoot.querySelector('form') : null;
              if (form) {
                _context4.next = 6;
                break;
              }
              throw new Error('<form> not found');
            case 6:
              if (form.checkValidity()) {
                _context4.next = 8;
                break;
              }
              return _context4.abrupt("return");
            case 8:
              _context4.next = 10;
              return loginAlreadyUsedAsync((_this$profile$email = this.profile.email) !== null && _this$profile$email !== void 0 ? _this$profile$email : '');
            case 10:
              emailAlreadyUsed = _context4.sent;
              _context4.next = 13;
              return has('PPE-AccountSwitchingMerge');
            case 13:
              allowMerge = _context4.sent;
              if (!(emailAlreadyUsed && this.profile.email !== this.initialEmail)) {
                _context4.next = 35;
                break;
              }
              if (allowMerge) {
                _context4.next = 21;
                break;
              }
              _context4.t0 = Error;
              _context4.next = 19;
              return translate('account.emailUsed');
            case 19:
              _context4.t1 = _context4.sent;
              throw new _context4.t0(_context4.t1);
            case 21:
              _context4.next = 23;
              return checkPasswordForAccountMerge((_this$profile$email2 = this.profile.email) !== null && _this$profile$email2 !== void 0 ? _this$profile$email2 : '');
            case 23:
              merge = _context4.sent;
              if (!merge) {
                _context4.next = 33;
                break;
              }
              _context4.next = 27;
              return linkExistingAccountWithLogin((_this$profile$email3 = this.profile.email) !== null && _this$profile$email3 !== void 0 ? _this$profile$email3 : '');
            case 27:
              mergeResult = _context4.sent;
              if (!(mergeResult.code >= 400)) {
                _context4.next = 30;
                break;
              }
              throw mergeResult;
            case 30:
              this.addAlert('account.mergeSuccess', 'success');
              _context4.next = 34;
              break;
            case 33:
              this.focusPasswordInput();
            case 34:
              return _context4.abrupt("return");
            case 35:
              _context4.next = 37;
              return this.saveUserAsync(this.profile);
            case 37:
              _context4.next = 39;
              return has('Platform_NotifyUpdatedEmail');
            case 39:
              hasNotification = _context4.sent;
              shouldDisplayAlert = this.profile.email !== this.initialEmail && hasNotification;
              if (shouldDisplayAlert) {
                this.addAlert('account.emailNotification', 'success');
                this.alertCloseHandler = this.closeSuccessMessageCallback;
              } else {
                this.dispatchEvent(new CustomEvent('save-account', {
                  bubbles: true,
                  composed: true,
                  detail: this.profile
                }));
              }
              changeLanguage((_this$profile$languag = this.profile.language) !== null && _this$profile$languag !== void 0 ? _this$profile$languag : 'en-US');
              this.initialEmail = this.profile.email;
              _context4.next = 49;
              break;
            case 46:
              _context4.prev = 46;
              _context4.t2 = _context4["catch"](2);
              this.addAlert(normalizeError(_context4.t2), 'danger');
            case 49:
              _context4.prev = 49;
              this.working = false;
              return _context4.finish(49);
            case 52:
            case "end":
              return _context4.stop();
          }
        }, _callee3, this, [[2, 46, 49, 52]]);
      }));
      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }()
  }, {
    key: "onCancel",
    value: function () {
      var _onCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this$profile$languag2;
        return _regeneratorRuntime.wrap(function _callee4$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(!this.hideLanguage && this.profileType === 'auth0' && this.initialLanguage !== this.profile.language)) {
                _context5.next = 4;
                break;
              }
              _context5.next = 3;
              return this.saveUserLanguageAsync(this.profile);
            case 3:
              changeLanguage((_this$profile$languag2 = this.profile.language) !== null && _this$profile$languag2 !== void 0 ? _this$profile$languag2 : 'en-US');
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee4, this);
      }));
      function onCancel() {
        return _onCancel.apply(this, arguments);
      }
      return onCancel;
    }()
  }, {
    key: "saveUserLanguageAsync",
    value: function () {
      var _saveUserLanguageAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(user) {
        return _regeneratorRuntime.wrap(function _callee8$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              return _context10.abrupt("return", getMeta().then( /*#__PURE__*/function () {
                var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref) {
                  var PrismGuid;
                  return _regeneratorRuntime.wrap(function _callee5$(_context6) {
                    while (1) switch (_context6.prev = _context6.next) {
                      case 0:
                        PrismGuid = _ref.PrismGuid;
                        if (PrismGuid) {
                          _context6.next = 3;
                          break;
                        }
                        throw new Error('bm.account.service.unableToLoadUser');
                      case 3:
                        return _context6.abrupt("return", _Promise.resolve(PrismGuid));
                      case 4:
                      case "end":
                        return _context6.stop();
                    }
                  }, _callee5);
                }));
                return function (_x2) {
                  return _ref2.apply(this, arguments);
                };
              }()).then( /*#__PURE__*/function () {
                var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(PrismGuid) {
                  var data;
                  return _regeneratorRuntime.wrap(function _callee7$(_context9) {
                    while (1) switch (_context9.prev = _context9.next) {
                      case 0:
                        data = {
                          language: user.language
                        };
                        return _context9.abrupt("return", getRoute('ProfileServices').then(function (base) {
                          var _context7;
                          return _concatInstanceProperty(_context7 = "".concat(base, "/v1/users/")).call(_context7, PrismGuid, "/language");
                        }).then( /*#__PURE__*/function () {
                          var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(url) {
                            return _regeneratorRuntime.wrap(function _callee6$(_context8) {
                              while (1) switch (_context8.prev = _context8.next) {
                                case 0:
                                  return _context8.abrupt("return", fetch(url, {
                                    body: _JSON$stringify(data),
                                    headers: jsonHeaders(),
                                    method: 'PUT'
                                  }));
                                case 1:
                                case "end":
                                  return _context8.stop();
                              }
                            }, _callee6);
                          }));
                          return function (_x4) {
                            return _ref4.apply(this, arguments);
                          };
                        }()));
                      case 2:
                      case "end":
                        return _context9.stop();
                    }
                  }, _callee7);
                }));
                return function (_x3) {
                  return _ref3.apply(this, arguments);
                };
              }()).then(http500Thrower));
            case 1:
            case "end":
              return _context10.stop();
          }
        }, _callee8);
      }));
      function saveUserLanguageAsync(_x) {
        return _saveUserLanguageAsync.apply(this, arguments);
      }
      return saveUserLanguageAsync;
    }()
  }, {
    key: "saveUserAsync",
    value: function () {
      var _saveUserAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(user) {
        var normalizeUserModel;
        return _regeneratorRuntime.wrap(function _callee11$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              normalizeUserModel = function _normalizeUserModel(user) {
                return {
                  email: user.email,
                  firstName: user.firstName,
                  language: user.language,
                  lastName: user.lastName,
                  middleName: user.middleName ? user.middleName : '',
                  prefix: user.prefix ? user.prefix : '',
                  suffix: user.suffix ? user.suffix : '',
                  photo: user.photo
                };
              };
              user = normalizeUserModel(user);
              return _context14.abrupt("return", getMeta().then( /*#__PURE__*/function () {
                var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref5) {
                  var PrismGuid;
                  return _regeneratorRuntime.wrap(function _callee10$(_context13) {
                    while (1) switch (_context13.prev = _context13.next) {
                      case 0:
                        PrismGuid = _ref5.PrismGuid;
                        if (PrismGuid) {
                          _context13.next = 3;
                          break;
                        }
                        throw new Error('bm.account.service.unableToLoadUser');
                      case 3:
                        return _context13.abrupt("return", getRoute('ProfileServices').then(function (base) {
                          var _context11;
                          return _concatInstanceProperty(_context11 = "".concat(base, "/v1/users/")).call(_context11, PrismGuid);
                        }).then( /*#__PURE__*/function () {
                          var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(url) {
                            return _regeneratorRuntime.wrap(function _callee9$(_context12) {
                              while (1) switch (_context12.prev = _context12.next) {
                                case 0:
                                  return _context12.abrupt("return", fetch(url, {
                                    body: _JSON$stringify(user),
                                    headers: jsonHeaders(),
                                    method: 'PUT'
                                  }));
                                case 1:
                                case "end":
                                  return _context12.stop();
                              }
                            }, _callee9);
                          }));
                          return function (_x7) {
                            return _ref7.apply(this, arguments);
                          };
                        }()));
                      case 4:
                      case "end":
                        return _context13.stop();
                    }
                  }, _callee10);
                }));
                return function (_x6) {
                  return _ref6.apply(this, arguments);
                };
              }()).then(http500Thrower));
            case 3:
            case "end":
              return _context14.stop();
          }
        }, _callee11);
      }));
      function saveUserAsync(_x5) {
        return _saveUserAsync.apply(this, arguments);
      }
      return saveUserAsync;
    }()
  }, {
    key: "showTermsAndConditions",
    value: function () {
      var _showTermsAndConditions2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(terms, signatory) {
        var result;
        return _regeneratorRuntime.wrap(function _callee12$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.prev = 0;
              _context15.next = 3;
              return showTermsAndConditions(terms, signatory);
            case 3:
              result = _context15.sent;
              if (result) {
                this.signatory = {};
              }
              _context15.next = 10;
              break;
            case 7:
              _context15.prev = 7;
              _context15.t0 = _context15["catch"](0);
              this.addAlert(normalizeError(_context15.t0), 'danger');
            case 10:
              _context15.prev = 10;
              this.working = false;
              return _context15.finish(10);
            case 13:
            case "end":
              return _context15.stop();
          }
        }, _callee12, this, [[0, 7, 10, 13]]);
      }));
      function showTermsAndConditions$1(_x8, _x9) {
        return _showTermsAndConditions2.apply(this, arguments);
      }
      return showTermsAndConditions$1;
    }()
  }, {
    key: "renderLanguageSelect",
    value: function renderLanguageSelect(profile) {
      return this.html(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteral(["<label>\n      <span>", " *</span>\n      <span>\n        <bm-select large>\n          <select\n            required\n            value=\"", "\"\n            @change=\"", "\">\n            ", "\n          </select>\n        </bm-select>\n      </span>\n    </label>"])), this.i18n('account.language'), profile.language, assigner(this, 'profile', 'language'), this._renderLanguageOptions());
    }
  }, {
    key: "renderMiddleNameInput",
    value: function renderMiddleNameInput(middleName) {
      if (this.hideProfileMiddleNameToBr) {
        return this.html(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteral([""])));
      }
      return this.html(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteral(["\n      <label>\n        <span>", "</span>\n        <span>\n          <input\n            class=\"bm-input max-width\"\n            type=\"text\"\n            value=\"", "\"\n            @change=\"", "\">\n        </span>\n      </label>\n    "])), this.i18n('account.name.middle'), ifDefined(middleName), assigner(this, 'profile', 'middleName'));
    }
  }, {
    key: "renderForm",
    value: function renderForm(profile) {
      return this.html(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteral(["<form method=\"post\">\n      <label>\n        <span>", " *</span>\n        <span>\n          <input\n            type=\"email\"\n            class=\"bm-input max-width\"\n            required\n            value=\"", "\"\n            @change=\"", "\"\n            @input=\"", "\"\n            maxlength=\"250\"\n            autocorrect=\"off\"\n            autocapitalize=\"off\"\n            spellcheck=\"false\">\n        </span>\n      </label>\n      <div class=\"sub-group\">\n        <label>\n          <span>", " *</span>\n          <span>\n            <input\n              type=\"text\"\n              class=\"bm-input max-width\"\n              name=\"first-name\"\n              required\n              maxlength=\"150\"\n              value=\"", "\"\n              @change=\"", "\"\n              @input=\"", "\">\n          </span>\n        </label>\n        ", "\n        <label>\n          <span>", " *</span>\n          <span>\n            <input\n              class=\"bm-input max-width\"\n              name=\"last-name\"\n              type=\"text\"\n              required\n              maxlength=\"150\"\n              value=\"", "\"\n              @change=\"", "\"\n              @input=\"", "\">\n          </span>\n        </label>\n      </div>\n      ", "\n      <label>\n        <span>* ", "</span>\n      </label>\n    </form>"])), this.i18n('account.email'), ifDefined(profile.email), assigner(this, 'profile', 'email'), this.checkEmailValidity.bind(this), this.i18n('account.name.first'), ifDefined(profile.firstName), assigner(this, 'profile', 'firstName'), this.checkNameValidity.bind(this), this.hideMiddleName ? null : this.renderMiddleNameInput(profile.middleName), this.i18n('account.name.last'), ifDefined(profile.lastName), assigner(this, 'profile', 'lastName'), this.checkNameValidity.bind(this), this.hideLanguage ? null : this.renderLanguageSelect(profile), this.i18n('common.requiredField'));
    }
  }, {
    key: "renderAuth0Profile",
    value: function renderAuth0Profile(profile) {
      return this.html(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteral(["<form>\n      <label>\n        <span>", "</span>\n      </label>\n       <span><strong>", "</strong></span>\n      <label>\n        <span>", "</span>\n      </label>\n      <span><strong>", " ", "</strong></span>\n      <p>", "</p>\n      ", "\n    </form>"])), this.i18n('account.email'), ifDefined(profile.email), this.i18n('account.name'), ifDefined(profile.firstName), ifDefined(profile.lastName), this.i18n('account.manageSettings'), this.hideLanguage ? null : this.renderLanguageSelect(profile));
    }
  }, {
    key: "renderViewTermn",
    value: function renderViewTermn(terms, signatory) {
      return this.html(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteral(["\n      <button\n        slot=\"buttons\"\n        @click=\"", "\"\n        class=\"bm-button link\">\n        ", "\n      </button>\n    "])), this.showTermsAndConditions.bind(this, terms, signatory), this.i18n('account.showTermsAndConditions'));
    }
  }, {
    key: "focusPasswordInput",
    value: function focusPasswordInput() {
      var emailField = this.shadowRoot ? this.shadowRoot.querySelector('input[type="email"]') : null;
      if (emailField) {
        emailField.focus();
      }
    }
  }, {
    key: "_renderLanguageOptions",
    value: function _renderLanguageOptions() {
      var _this2 = this;
      return repeat(this.languages, function (i) {
        return i.code;
      }, function (lang) {
        return _this2.html(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteral(["\n      <option\n        ?selected=\"", "\"\n        label=\"", "\"\n        value=\"", "\">\n          ", "\n      </option>"])), _this2.profile.language === lang.code, lang.description, lang.code, lang.description);
      });
    }
  }, {
    key: "checkNameValidity",
    value: function () {
      var _checkNameValidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(event) {
        var target, msg;
        return _regeneratorRuntime.wrap(function _callee13$(_context16) {
          while (1) switch (_context16.prev = _context16.next) {
            case 0:
              target = event.target;
              target.setCustomValidity('');
              target.removeAttribute('data-customError');
              if (!(target.value.length > 100)) {
                _context16.next = 9;
                break;
              }
              _context16.next = 6;
              return translate('account.maxlength');
            case 6:
              msg = _context16.sent;
              target.setAttribute('data-customError', msg);
              target.setCustomValidity(msg);
            case 9:
            case "end":
              return _context16.stop();
          }
        }, _callee13);
      }));
      function checkNameValidity(_x10) {
        return _checkNameValidity.apply(this, arguments);
      }
      return checkNameValidity;
    }()
  }, {
    key: "checkEmailValidity",
    value: function () {
      var _checkEmailValidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(event) {
        var target, beforeAt, msg;
        return _regeneratorRuntime.wrap(function _callee14$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              target = event.target;
              target.setCustomValidity('');
              target.removeAttribute('data-customError');
              beforeAt = target.value.split('@')[0];
              if (!(beforeAt.length > 64)) {
                _context17.next = 10;
                break;
              }
              _context17.next = 7;
              return translate('account.emailUserNameLengthExceededError');
            case 7:
              msg = _context17.sent;
              target.setAttribute('data-customError', msg);
              target.setCustomValidity(msg);
            case 10:
            case "end":
              return _context17.stop();
          }
        }, _callee14);
      }));
      function checkEmailValidity(_x11) {
        return _checkEmailValidity.apply(this, arguments);
      }
      return checkEmailValidity;
    }()
  }, {
    key: "_renderRefreshIcon",
    value: function _renderRefreshIcon() {
      return this.svg(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteral(["\n      <svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 0 32 32\">\n       <path d=\"M27.802 5.197c-2.925-3.194-7.13-5.197-11.803-5.197-8.837 0-16 7.163-16 16h3c0-7.18 5.82-13 13-13 3.844 0 7.298 1.669 9.678 4.322l-4.678 4.678h11v-11l-4.198 4.197z\"></path>\n       <path d=\"M29 16c0 7.18-5.82 13-13 13-3.844 0-7.298-1.669-9.678-4.322l4.678-4.678h-11v11l4.197-4.197c2.925 3.194 7.13 5.197 11.803 5.197 8.837 0 16-7.163 16-16h-3z\"></path>\n      </svg>"])));
    }
  }, {
    key: "updateUserData",
    value: function () {
      var _updateUserData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context18) {
          while (1) switch (_context18.prev = _context18.next) {
            case 0:
              _context18.prev = 0;
              _context18.next = 3;
              return _Promise.resolve(getCurrentUser());
            case 3:
              this.profile = _context18.sent;
              this.initialEmail = this.profile.email;
              _context18.next = 10;
              break;
            case 7:
              _context18.prev = 7;
              _context18.t0 = _context18["catch"](0);
              this.addAlert(normalizeError(_context18.t0), 'danger');
            case 10:
            case "end":
              return _context18.stop();
          }
        }, _callee15, this, [[0, 7]]);
      }));
      function updateUserData() {
        return _updateUserData.apply(this, arguments);
      }
      return updateUserData;
    }()
  }, {
    key: "_renderRefreshButton",
    value: function _renderRefreshButton() {
      return this.html(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n      <div>\n        <button\n          @click=\"", "\"\n          type=\"refresh-btn\"\n          class=\"bm-button md refresh-btn\">\n          ", " &nbsp; ", "\n        </button>\n      </div>\n    "])), this.updateUserData.bind(this), this._renderRefreshIcon(), this.i18n('account.refresh'));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-settings-account-information';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        isClient: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        mode: {
          type: String,
          attribute: true,
          reflect: true
        },
        profileType: {
          type: String,
          attribute: true,
          reflect: true
        },
        profile: {
          type: Object,
          attribute: false,
          reflect: false
        },
        working: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        terms: {
          type: Object,
          attribute: false,
          reflect: false
        },
        signatory: {
          type: Object,
          attribute: false,
          reflect: false
        },
        hideLanguage: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        hideMiddleName: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        initialEmail: {
          type: String,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, formStyle, bmButtonStyle, bmInputStyle, style$c];
    }
  }]);
  return BmSettingsAccountInformation;
}(alertsMixin(i18nMixin(BlueElement)));
var registerAccountInformation = function registerAccountInformation() {
  registerLanguage$2();
  registerAlerts();
  registerSelect();
  registerLoading();
  registerPageLayout();
  registerTerms();
  register$1(BmSettingsAccountInformation);
};

var _templateObject$b, _templateObject2$b;
var style$b = css(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral(["\n  :host {\n    display: flex;\n    flex-direction: column;\n    contain: content;\n    font-size: 14px;\n  }\n  :host([hidden]) {\n    display: none;\n  }\n\n  :host .name,\n  :host .firm {\n    line-height: 20px;\n    display: block;\n    font-family: KnowledgeRegular, 'Helvetica Neue', Arial, sans-serif;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    overflow: hidden;\n    max-width: 100%;\n  }\n\n  :host .name {\n    font-size: 1em;\n  }\n\n  :host .firm {\n    font-size: 0.8rem;\n  }\n"])));
var BmLinkedAccountDetail = /*#__PURE__*/function (_BlueElement) {
  _inherits(BmLinkedAccountDetail, _BlueElement);
  var _super = _createSuper(BmLinkedAccountDetail);
  function BmLinkedAccountDetail() {
    var _context;
    var _this;
    _classCallCheck(this, BmLinkedAccountDetail);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
    _this.account = {};
    return _this;
  }
  _createClass(BmLinkedAccountDetail, [{
    key: "render",
    value: function render() {
      var _this$account, _this$account2;
      return this.html(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteral(["\n      <span class=\"name\">\n        ", "\n      </span>\n      <span class=\"firm\">\n        ", "\n      </span>\n    "])), (_this$account = this.account) !== null && _this$account !== void 0 && _this$account.displayedNickname ? this.account.displayedNickname : (_this$account2 = this.account) === null || _this$account2 === void 0 ? void 0 : _this$account2.accountName, this.account.companyName);
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-linked-account-detail';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        account: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, style$b];
    }
  }]);
  return BmLinkedAccountDetail;
}(BlueElement);
var registerAccountDetail = function registerAccountDetail() {
  return register$1(BmLinkedAccountDetail);
};

var _templateObject$a, _templateObject2$a, _templateObject3$7;
var style$a = css(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n  :host {\n    display: flex;\n    flex-direction: column;\n    contain: content;\n    font-family: Arial, 'Helvetica Neue', sans-serif;\n    font-size: 14px;\n    font-style: normal;\n    line-height: 22px;\n  }\n"])));
var BmLinkedAccountAdd = /*#__PURE__*/function (_alertsMixin) {
  _inherits(BmLinkedAccountAdd, _alertsMixin);
  var _super = _createSuper(BmLinkedAccountAdd);
  function BmLinkedAccountAdd() {
    var _context;
    var _this;
    _classCallCheck(this, BmLinkedAccountAdd);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
    _this.email = '';
    _this.password = '';
    _this.working = false;
    return _this;
  }
  _createClass(BmLinkedAccountAdd, [{
    key: "render",
    value: function render() {
      return this.html(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteral(["\n      <bm-alerts></bm-alerts>\n      <div>", "</div>\n      <div><strong>\"", "\"</strong></div>\n      <form method=\"POST\" @submit=\"", "\">\n        <label>\n          <span>", "</span>\n            <span>\n              <input\n                autofocus\n                class=\"bm-input max-width\"\n                maxlength=200\n                value=\"", "\"\n                @input=\"", "\"\n                type=\"type\">\n            </span>\n        </label>\n\n        <label>\n          <span>", "</span>\n          <span>\n            <input\n              autofocus\n              class=\"bm-input max-width\"\n              maxlength=50\n              value=\"", "\"\n              @input=\"", "\"\n              type=\"password\">\n          </span>\n        </label>\n\n        <footer>\n          <button\n            class=\"bm-button primary md\"\n            type=\"submit\">\n              ", "\n          </button>\n          <button\n            class=\"bm-button outline primary md\"\n            type=\"button\"\n            @click=\"", "\">\n              ", "\n          </button>\n        </footer>\n        <bm-loading ?active=\"", "\"></bm-loading>\n      </form>\n    "])), this.i18n('linkedAccount.add.description'), window.curEmail, this.onSave.bind(this), this.i18n('linkedAccount.add.email'), this.email, this.onEmailChange.bind(this), this.i18n('linkedAccount.add.password'), this.password, this.onPasswordChange.bind(this), this.i18n('common.save'), this.onCancel.bind(this), this.i18n('common.cancel'), this.working);
    }
  }, {
    key: "onSave",
    value: function () {
      var _onSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var _context2, _context3;
        var emailRegex, body, response, data, dataError;
        return _regeneratorRuntime.wrap(function _callee$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              event.preventDefault();
              event.stopPropagation();
              emailRegex = new RegExp("^((([a-z]|\\d|[!#\\$%&'\\*\\+\\-\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+(\\.([a-z]|\\d|[!#\\$%&'\\*\\+\\-" + "\\/=\\?\\^_`{\\|}~]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])+)*)|((\\x22)((((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(([\\x01-\\x08\\x0b" + "\\x0c\\x0e-\\x1f\\x7f]|\\x21|[\\x23-\\x5b]|[\\x5d-\\x7e]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(\\\\([\\x01-\\x09\\x0b\\x0c\\x0d-\\x7f]|" + "[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF]))))*(((\\x20|\\x09)*(\\x0d\\x0a))?(\\x20|\\x09)+)?(\\x22)))@((([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-" + "\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-" + "\\uFFEF])*([a-z]|\\d|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.)+(([a-z]|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])|(([a-z]|" + "[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])([a-z]|\\d|-|\\.|_|~|[\\u00A0-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFEF])*([a-z]|[\\u00A0-\\uD7FF" + "\\uF900-\\uFDCF\\uFDF0-\\uFFEF])))\\.?$", 'i');
              if (!(this.email === undefined || _trimInstanceProperty(_context2 = this.email).call(_context2) === '' || this.password === undefined || _trimInstanceProperty(_context3 = this.password).call(_context3) === '')) {
                _context4.next = 6;
                break;
              }
              this.replaceAlerts(instantTranslate('linkedAccount.add.alert.notEmpty'), 'danger');
              return _context4.abrupt("return");
            case 6:
              if (!(emailRegex.exec(this.email) === null)) {
                _context4.next = 9;
                break;
              }
              this.replaceAlerts(instantTranslate('linkedAccount.add.alert.wrongEmailFormat'), 'danger');
              return _context4.abrupt("return");
            case 9:
              this.working = true;
              body = {
                uid: this.email,
                pwd: this.password
              };
              _context4.prev = 11;
              _context4.next = 14;
              return fetch(window.location.origin + '/api/profiles/v2/accounts/merge', {
                method: 'PUT',
                headers: {
                  Accept: 'application/json',
                  'Content-Type': 'application/json'
                },
                body: _JSON$stringify(body)
              });
            case 14:
              response = _context4.sent;
              if (!(response.status === 400)) {
                _context4.next = 22;
                break;
              }
              _context4.next = 18;
              return response.json();
            case 18:
              data = _context4.sent;
              if (data.Message[0] === 'Unable to confirm your password. Please try again.') {
                this.replaceAlerts(instantTranslate('linkedAccount.add.alert.wrongPassword'), 'danger');
              } else if (data.Message[0] === 'Cannot link accounts that are in the same company') {
                this.replaceAlerts(instantTranslate('linkedAccount.add.alert.wrongCompany'), 'danger');
              } else if (data.Message[0] === 'Deactivated account. Please contact your administrator') {
                this.replaceAlerts(instantTranslate('linkedAccount.add.alert.deactivatedAccount'), 'danger');
              } else {
                this.replaceAlerts(data.Message[0], 'danger');
              }
              _context4.next = 23;
              break;
            case 22:
              this.dispatchEvent(new CustomEvent('save'));
            case 23:
              _context4.next = 32;
              break;
            case 25:
              _context4.prev = 25;
              _context4.t0 = _context4["catch"](11);
              this.addAlert(normalizeError(_context4.t0), 'danger');
              _context4.next = 30;
              return _context4.t0.json();
            case 30:
              dataError = _context4.sent;
              this.replaceAlerts(dataError.Message[0], 'danger');
            case 32:
              _context4.prev = 32;
              this.working = false;
              return _context4.finish(32);
            case 35:
            case "end":
              return _context4.stop();
          }
        }, _callee, this, [[11, 25, 32, 35]]);
      }));
      function onSave(_x) {
        return _onSave.apply(this, arguments);
      }
      return onSave;
    }()
  }, {
    key: "onCancel",
    value: function onCancel() {
      this.dispatchEvent(new CustomEvent('cancel'));
    }
  }, {
    key: "onEmailChange",
    value: function onEmailChange(event) {
      var _event$target;
      this.email = (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.value ? event.target.value : undefined;
    }
  }, {
    key: "onPasswordChange",
    value: function onPasswordChange(event) {
      var _event$target2;
      this.password = (_event$target2 = event.target) !== null && _event$target2 !== void 0 && _event$target2.value ? event.target.value : undefined;
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-linked-account-add';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        email: {
          type: String,
          attribute: true,
          reflect: false
        },
        password: {
          type: String,
          attribute: true,
          reflect: false
        },
        working: {
          type: Boolean,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, formStyle, bmButtonStyle, bmInputStyle, style$a];
    }
  }]);
  return BmLinkedAccountAdd;
}(alertsMixin(i18nMixin(BlueElement)));
var registerLinkedAccountAdd = function registerLinkedAccountAdd() {
  registerLanguage$4();
  registerAlerts();
  registerModal();
  registerLoading();
  registerAccountDetail();
  register$1(BmLinkedAccountAdd);
};
function addAccount() {
  return _addAccount.apply(this, arguments);
}
function _addAccount() {
  _addAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          return _context5.abrupt("return", new _Promise(function (resolve) {
            var onSave = function onSave(event) {
              removeModal();
              resolve(event.detail);
            };
            var onCancel = function onCancel() {
              removeModal();
              resolve();
            };
            var removeModal = createModal(html(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteral(["\n        <style>\n          :host .surface {\n            width: 430px;\n          }\n        </style>\n        <bm-linked-account-add @save=\"", "\" @cancel=\"", "\"> </bm-linked-account-add>\n      "])), onSave, onCancel), 'linkedAccount.add.title');
          }));
        case 1:
        case "end":
          return _context5.stop();
      }
    }, _callee2);
  }));
  return _addAccount.apply(this, arguments);
}

var _templateObject$9, _templateObject2$9, _templateObject3$6;
var style$9 = css(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n  :host {\n    display: flex;\n    flex-direction: column;\n    contain: content;\n    font-family: Arial, 'Helvetica Neue', sans-serif;\n    font-size: 14px;\n  }\n  :host([hidden]) {\n    display: none;\n  }\n\n  :host .preview {\n    display: flex;\n    justify-content: stretch;\n    margin-bottom: 50px;\n  }\n  :host .preview > span {\n    flex-grow: 0;\n    flex-shrink: 1;\n    margin-right: 70px;\n  }\n  :host .preview > bm-linked-account-detail {\n    flex-grow: 1;\n    flex-shrink: 1;\n    padding: 15px;\n    border-top: solid 1px #d5d4d9;\n    border-bottom: solid 1px #d5d4d9;\n  }\n"])));
var BmSettingsLinkedAccountsEdit = /*#__PURE__*/function (_alertsMixin) {
  _inherits(BmSettingsLinkedAccountsEdit, _alertsMixin);
  var _super = _createSuper(BmSettingsLinkedAccountsEdit);
  function BmSettingsLinkedAccountsEdit() {
    var _context;
    var _this;
    _classCallCheck(this, BmSettingsLinkedAccountsEdit);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
    _this.account = {};
    _this.nickname = '';
    _this.working = false;
    return _this;
  }
  _createClass(BmSettingsLinkedAccountsEdit, [{
    key: "render",
    value: function render() {
      var _this$nickname, _this$nickname2;
      var nickname = (_this$nickname = this.nickname) !== null && _this$nickname !== void 0 ? _this$nickname : this.account.displayedNickname;
      var newAccount = _objectSpread(_objectSpread({}, this.account), {}, {
        displayedNickname: this.nickname === undefined ? this.account.accountName : nickname
      });
      return this.html(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteral(["\n      <bm-alerts></bm-alerts>\n      <p>", "</p>\n      <form method=\"POST\" @submit=\"", "\">\n        <label>\n          <span>", "</span>\n          <span>\n            <input\n              autofocus\n              class=\"bm-input max-width\"\n              maxlength=50\n              value=\"", "\"\n              @input=\"", "\"\n              type=\"type\">\n          </span>\n        </label>\n        <div class=\"preview\">\n          <span>", ":</span>\n          <bm-linked-account-detail\n            .account=\"", "\">\n          </bm-linked-account-detail>\n        </div>\n        <footer>\n          <button\n            class=\"bm-button primary md\"\n            type=\"submit\">\n              ", "\n          </button>\n          <button\n            class=\"bm-button outline primary md\"\n            type=\"button\"\n            @click=\"", "\">\n              ", "\n          </button>\n        </footer>\n        <bm-loading ?active=\"", "\"></bm-loading>\n      </form>\n    "])), this.i18n('linkedAccounts.edit.description'), this.onSave.bind(this), this.i18n('linkedAccounts.edit.nickname'), ifDefined((_this$nickname2 = this.nickname) !== null && _this$nickname2 !== void 0 ? _this$nickname2 : nickname), this.onNicknameChange.bind(this), this.i18n('common.preview'), newAccount, this.i18n('common.save'), this.onCancel.bind(this), this.i18n('common.cancel'), this.working);
    }
  }, {
    key: "onSave",
    value: function () {
      var _onSave = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(event) {
        var _ref;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              event.preventDefault();
              event.stopPropagation();
              this.working = true;
              _context2.prev = 3;
              if (!(this.nickname !== this.account.displayedNickname)) {
                _context2.next = 8;
                break;
              }
              this.account.displayedNickname = this.nickname === undefined ? '' : (_ref = this.nickname || this.account.displayedNickname) !== null && _ref !== void 0 ? _ref : '';
              _context2.next = 8;
              return updateAccounts([this.account]);
            case 8:
              this.dispatchEvent(new CustomEvent('save', {
                detail: this.account
              }));
              _context2.next = 14;
              break;
            case 11:
              _context2.prev = 11;
              _context2.t0 = _context2["catch"](3);
              this.replaceAlerts(normalizeError(_context2.t0), 'danger');
            case 14:
              _context2.prev = 14;
              this.working = false;
              return _context2.finish(14);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee, this, [[3, 11, 14, 17]]);
      }));
      function onSave(_x) {
        return _onSave.apply(this, arguments);
      }
      return onSave;
    }()
  }, {
    key: "onCancel",
    value: function onCancel() {
      this.dispatchEvent(new CustomEvent('cancel'));
    }
  }, {
    key: "onNicknameChange",
    value: function onNicknameChange(event) {
      var _event$target;
      this.nickname = (_event$target = event.target) !== null && _event$target !== void 0 && _event$target.value ? event.target.value : undefined;
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-settings-linked-accounts-edit';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        account: {
          type: Object,
          attribute: false,
          reflect: false
        },
        nickname: {
          type: String,
          attribute: true,
          reflect: true
        },
        working: {
          type: Boolean,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, formStyle, bmButtonStyle, bmInputStyle, style$9];
    }
  }]);
  return BmSettingsLinkedAccountsEdit;
}(alertsMixin(i18nMixin(BlueElement)));
var registerLinkedAccountsEdit = function registerLinkedAccountsEdit() {
  registerLanguage$4();
  registerAlerts();
  registerModal();
  registerLoading();
  registerAccountDetail();
  register$1(BmSettingsLinkedAccountsEdit);
};
function editAccount(_x2) {
  return _editAccount.apply(this, arguments);
}
function _editAccount() {
  _editAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(account) {
    return _regeneratorRuntime.wrap(function _callee2$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          return _context3.abrupt("return", new _Promise(function (resolve) {
            var onSave = function onSave(event) {
              removeModal();
              resolve(event.detail);
            };
            var onCancel = function onCancel() {
              removeModal();
              resolve(account);
            };
            var removeModal = createModal(html(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteral(["\n        <style>\n          :host .surface {\n            width: 430px;\n          }\n        </style>\n        <bm-settings-linked-accounts-edit .account=\"", "\" @save=\"", "\" @cancel=\"", "\">\n        </bm-settings-linked-accounts-edit>\n      "])), account, onSave, onCancel), 'linkedAccounts.edit.title');
          }));
        case 1:
        case "end":
          return _context3.stop();
      }
    }, _callee2);
  }));
  return _editAccount.apply(this, arguments);
}

var products = {
  samba: 'samba',
  onvio: 'onvio'
};

var _templateObject$8, _templateObject2$8, _templateObject3$5, _templateObject4$5, _templateObject5$5, _templateObject6$2, _templateObject7$1, _templateObject8$1, _templateObject9, _templateObject10;
function sortAccountsFn(a, b) {
  if ((a.linkedAccountId || '') < (b.linkedAccountId || '')) return -1;
  if (a.linkedAccountId || (b.linkedAccountId || '') < '') return 1;
  return 0;
}
var style$8 = css(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n  :host {\n    display: flex;\n    contain: content;\n    font-family: Arial, 'Helvetica Neue', sans-serif;\n    font-size: 14px;\n    color: #212121;\n  }\n  :host([hidden]) {\n    display: none;\n  }\n  :host .addIcon {\n    margin-top: -4px;\n  }\n  :host .addAccount {\n    display: flex;\n    color: #0072a8;\n    stroke: #0072a8;\n    cursor: pointer;\n  }\n  :host .addAccount:hover {\n    display: flex;\n    cursor: pointer;\n    color: rgb(0, 88, 133);\n  }\n\n  :host .cards {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n  }\n\n  :host bm-settings-page-layout {\n    flex: 0 1 100%; /* This is only needed for IE */\n  }\n\n  :host .card {\n    display: flex;\n    flex-direction: column;\n    box-shadow: 2px 2px 13px 0px rgba(174, 174, 174, 0.349019607843137);\n    margin-right: 20px;\n    margin-bottom: 20px;\n    width: 270px;\n  }\n\n  :host .card .title {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    background-color: #212121;\n    color: white;\n    fill: white;\n    padding: 11px 13px;\n    font-family: KnowledgeRegular, 'Helvetica Neue', Arial, sans-serif;\n    font-size: 1rem;\n  }\n\n  :host .card .title > * {\n    flex-shrink: 1;\n    min-width: 0;\n  }\n\n  :host .card .title svg {\n    cursor: pointer;\n    /*\n      This is to override when ShadyCSS doesn't work correctly in IE11\n      TODO: Remove when all suppported browser have ShadowDOM\n    */\n    animation-name: none;\n    height: 16px;\n    width: 16px;\n  }\n\n  :host .card.inactive .title {\n    background-color: #d5d4d9;\n    color: #212121;\n    fill: #212121;\n  }\n\n  :host .card .footer.default {\n    background-color: #d4ebf4;\n  }\n\n  :host .card .footer {\n    border-top: solid 1px #d5d4d9;\n    display: flex;\n    min-height: 2.5em;\n    align-items: center;\n    padding-left: 10px;\n  }\n\n  :host .card .footer .bm-button.link {\n    line-height: 1.5em;\n  }\n\n  :host .card .footer bm-popover {\n    margin-left: 10px;\n  }\n\n  :host .card .content {\n    display: flex;\n    padding: 10px;\n    flex-grow: 1;\n    padding-bottom: 40px;\n  }\n\n  :host .card.inactive .content {\n    background-color: #f4f5f7;\n  }\n\n  :host .card .content > bm-toggle {\n    flex-shrink: 0;\n    flex-grow: 0;\n  }\n\n  :host .card .content > div {\n    padding-left: 10px;\n    display: flex;\n    flex-direction: column;\n    flex: 0 1 100%; /* This is only needed for IE */\n  }\n\n  :host .card .content .state {\n    font-size: 1.3em;\n    font-family: KnowledgeMedium, 'Helvetica Neue', Arial, sans-serif;\n  }\n\n  :host .card .content .state-desc {\n    font-family: KnowledgeLight, 'Helvetica Neue', Arial, sans-serif;\n  }\n  :host svg {\n    transform: scale(0.8);\n    margin-bottom: 1px;\n    /*\n      This is to override when ShadyCSS doesn't work correctly in IE11\n      TODO: Remove when all suppported browser have ShadowDOM\n    */\n    animation-name: none;\n  }\n"])));
var BmSettingsLinkedAccounts = /*#__PURE__*/function (_alertsMixin) {
  _inherits(BmSettingsLinkedAccounts, _alertsMixin);
  var _super = _createSuper(BmSettingsLinkedAccounts);
  function BmSettingsLinkedAccounts() {
    var _this;
    _classCallCheck(this, BmSettingsLinkedAccounts);
    _this = _super.call(this);
    _this.hideTitle = false;
    _this.product = products.onvio;
    _this.profileType = void 0;
    _this.accounts = [];
    _this.profile = {};
    _this.working = false;
    _this.commBus = void 0;
    _this.commBus = omnibus('linked-account');
    return _this;
  }
  _createClass(BmSettingsLinkedAccounts, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, profiles, accounts;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _get(_getPrototypeOf(BmSettingsLinkedAccounts.prototype), "connectedCallback", this).call(this);
              this.working = true;
              _context.prev = 2;
              _context.next = 5;
              return _Promise.all([getCurrentUser(), this.product === products.samba ? getAllOnbalanceLinkedAccounts() : getAllOnvioLinkedAccounts()]);
            case 5:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              profiles = _yield$Promise$all2[0];
              accounts = _yield$Promise$all2[1];
              this.profile = profiles;
              _context.next = 12;
              return not('Platform_DisableAuth0Phase2');
            case 12:
              if (!_context.sent) {
                _context.next = 16;
                break;
              }
              _context.t0 = 'auth0';
              _context.next = 17;
              break;
            case 16:
              _context.t0 = 'standard';
            case 17:
              this.profileType = _context.t0;
              this.accounts = accounts;
              if (accounts.length === 1) {
                accounts[0].home = true;
              }
              _context.next = 25;
              break;
            case 22:
              _context.prev = 22;
              _context.t1 = _context["catch"](2);
              this.replaceAlerts(normalizeError(_context.t1), 'danger');
            case 25:
              _context.prev = 25;
              this.working = false;
              return _context.finish(25);
            case 28:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 22, 25, 28]]);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this$profile$email;
      var emailStr = this.profile ? (_this$profile$email = this.profile.email) !== null && _this$profile$email !== void 0 ? _this$profile$email : '' : '';
      var linkedAccountsDescription = this.profileType === 'auth0' ? 'linkedAccounts.description.auth0' : 'linkedAccounts.description';
      window.curEmail = emailStr;
      return this.html(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteral(["\n      <bm-settings-page-layout\n        hideSave\n        label=\"", "\">\n        <bm-alerts></bm-alerts>\n        <div>\n          <p class= \"addAccount\" data-qe-id=\"add-linked-account\" @click=\"", "\">\n          <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"addIcon\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"#000000\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><circle cx=\"12\" cy=\"12\" r=\"10\"></circle><line x1=\"12\" y1=\"8\" x2=\"12\" y2=\"16\"></line><line x1=\"8\" y1=\"12\" x2=\"16\" y2=\"12\"></line></svg>\n          ", "</p>\n          <p>\n            ", "\n          </p>\n          <div class=\"cards\">\n            ", "\n            ", "\n          </div>\n          <p>", "</p>\n        </div>\n      </bm-settings-page-layout>\n      <bm-loading ?active=\"", "\"></bm-loading>\n    "])), this.hideTitle ? '' : this.i18n('linkedAccounts.title'), this.addAccount.bind(this), this.i18nHTML('linkedAccounts.add'), this.i18nHTML(linkedAccountsDescription, {
        email: emailStr
      }), this.accounts.length === 0 ? this.i18n('linkedAccounts.noAccounts') : null, this.accounts.length >= 1 ? this._renderAccountsCards(this.accounts) : null, this.i18nHTML('linkedAccounts.subDescription'), this.working);
    }
  }, {
    key: "saveAccounts",
    value: function () {
      var _saveAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(accounts) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.working = true;
              _context2.prev = 1;
              this.commBus.dispatch('account-change', this.accounts, true);
              _context2.next = 5;
              return updateAccounts(accounts);
            case 5:
              _context2.next = 10;
              break;
            case 7:
              _context2.prev = 7;
              _context2.t0 = _context2["catch"](1);
              this.replaceAlerts(normalizeError(_context2.t0), 'danger');
            case 10:
              _context2.prev = 10;
              this.working = false;
              return _context2.finish(10);
            case 13:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 7, 10, 13]]);
      }));
      function saveAccounts(_x) {
        return _saveAccounts.apply(this, arguments);
      }
      return saveAccounts;
    }()
  }, {
    key: "toggleAccount",
    value: function () {
      var _toggleAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(account) {
        var _context3, _context4;
        return _regeneratorRuntime.wrap(function _callee3$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              account.active = !account.active;
              this.accounts = _concatInstanceProperty(_context3 = []).call(_context3, _toConsumableArray(_filterInstanceProperty(_context4 = this.accounts).call(_context4, function (a) {
                return a !== account;
              })), [_objectSpread({}, account)]);
              _context5.next = 4;
              return this.saveAccounts([account]);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee3, this);
      }));
      function toggleAccount(_x2) {
        return _toggleAccount.apply(this, arguments);
      }
      return toggleAccount;
    }()
  }, {
    key: "setAccountAsDefault",
    value: function () {
      var _setAccountAsDefault = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(account) {
        var _context6;
        var oldHome, _context7, _context8, _context9, _context10;
        return _regeneratorRuntime.wrap(function _callee4$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              oldHome = _findInstanceProperty(_context6 = this.accounts).call(_context6, function (a) {
                return Boolean(a.home);
              });
              account.home = true;
              if (!oldHome) {
                _context11.next = 9;
                break;
              }
              oldHome.home = false;
              this.accounts = _concatInstanceProperty(_context7 = []).call(_context7, _toConsumableArray(_filterInstanceProperty(_context8 = this.accounts).call(_context8, function (a) {
                return a !== account && a !== oldHome;
              })), [_objectSpread({}, account), _objectSpread({}, oldHome)]);
              _context11.next = 7;
              return this.saveAccounts([account, oldHome]);
            case 7:
              _context11.next = 12;
              break;
            case 9:
              this.accounts = _concatInstanceProperty(_context9 = []).call(_context9, _toConsumableArray(_filterInstanceProperty(_context10 = this.accounts).call(_context10, function (a) {
                return a !== account;
              })), [_objectSpread({}, account)]);
              _context11.next = 12;
              return this.saveAccounts([account]);
            case 12:
            case "end":
              return _context11.stop();
          }
        }, _callee4, this);
      }));
      function setAccountAsDefault(_x3) {
        return _setAccountAsDefault.apply(this, arguments);
      }
      return setAccountAsDefault;
    }()
  }, {
    key: "openEdit",
    value: function () {
      var _openEdit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(account) {
        var _context12, _context13;
        var updatedAccount;
        return _regeneratorRuntime.wrap(function _callee5$(_context14) {
          while (1) switch (_context14.prev = _context14.next) {
            case 0:
              _context14.next = 2;
              return editAccount(account);
            case 2:
              updatedAccount = _context14.sent;
              this.accounts = _concatInstanceProperty(_context12 = []).call(_context12, _toConsumableArray(_filterInstanceProperty(_context13 = this.accounts).call(_context13, function (a) {
                return a !== account;
              })), [_objectSpread({}, updatedAccount)]);
              this.commBus.dispatch('account-change', this.accounts, true);
            case 5:
            case "end":
              return _context14.stop();
          }
        }, _callee5, this);
      }));
      function openEdit(_x4) {
        return _openEdit.apply(this, arguments);
      }
      return openEdit;
    }()
  }, {
    key: "addAccount",
    value: function () {
      var _addAccount2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var isUberAdmin, isLinkingDisabled;
        return _regeneratorRuntime.wrap(function _callee6$(_context15) {
          while (1) switch (_context15.prev = _context15.next) {
            case 0:
              _context15.next = 2;
              return has$1('Platform.UberAdmin');
            case 2:
              isUberAdmin = _context15.sent;
              _context15.next = 5;
              return has('Platform_Disable_Admin_Linking');
            case 5:
              isLinkingDisabled = _context15.sent;
              if (!(isLinkingDisabled && isUberAdmin)) {
                _context15.next = 10;
                break;
              }
              this.replaceAlerts(instantTranslate('linkedAccounts.auth.cannotLinkAccount'), 'danger');
              _context15.next = 14;
              break;
            case 10:
              _context15.next = 12;
              return addAccount();
            case 12:
              _context15.next = 14;
              return this.connectedCallback();
            case 14:
            case "end":
              return _context15.stop();
          }
        }, _callee6, this);
      }));
      function addAccount$1() {
        return _addAccount2.apply(this, arguments);
      }
      return addAccount$1;
    }()
  }, {
    key: "infoPopoverContent",
    value: function infoPopoverContent() {
      return this.html(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteral(["<div style=\"margin: 15px;\">\n      ", "\n    </div>"])), this.i18n('linkedAccounts.defaultHelp'));
    }
  }, {
    key: "editPopoverContent",
    value: function editPopoverContent() {
      return this.html(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteral(["<div style=\"margin: 15px;\">\n      ", "\n    </div>"])), this.i18n('linkedAccounts.edit.popover'));
    }
  }, {
    key: "renderDefaultInfo",
    value: function renderDefaultInfo() {
      return this.html(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteral(["\n    <bm-popover .content=\"", "\" trigger=\"mouse\">\n      ", "\n    </bm-popover>"])), this.infoPopoverContent(), help);
    }
  }, {
    key: "renderDefaultFooter",
    value: function renderDefaultFooter() {
      return this.html(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteral(["\n    <div class=\"footer default\">\n      ", "\n      ", "\n    </div>"])), this.i18n('linkedAccounts.defaultAccount'), this.renderDefaultInfo());
    }
  }, {
    key: "renderNotDefaultFooter",
    value: function renderNotDefaultFooter(account) {
      return this.html(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteral(["<div class=\"footer\">\n      <button\n        class=\"bm-button link\"\n        @click=\"", "\">\n        ", "\n      </button>\n      ", "\n    </div>"])), this.setAccountAsDefault.bind(this, account), this.i18n('linkedAccounts.setDefaultAccount'), this.renderDefaultInfo());
    }
  }, {
    key: "renderAccountCard",
    value: function renderAccountCard(account) {
      return this.html(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteral(["\n      <div class=\"card ", "\">\n        <div class=\"title\">\n          <bm-linked-account-detail\n            .account=\"", "\">\n          </bm-linked-account-detail>\n          <bm-popover .content=\"", "\" trigger=\"mouse\">\n            ", "\n          </bm-popover>\n        </div>\n        <div class=\"content\">\n          <bm-toggle\n            ?disabled=\"", "\"\n            ?on=\"", "\"\n            @change=\"", "\">\n          </bm-toggle>\n          <div>\n            <span class=\"state\">\n              ", "\n            </span>\n            <span class=\"state-desc\">\n              ", "\n            </span>\n          </div>\n        </div>\n        ", "\n      </div>\n    "])), account.active ? '' : 'inactive', account, this.editPopoverContent(), this._renderEditIcon(account), account.home, account.active, this.toggleAccount.bind(this, account), this.i18n(account.active ? 'common.active' : 'common.inactive'), this.i18n(account.active ? 'linkedAccounts.active.description' : 'linkedAccounts.inactive.description'), account.active ? account.home ? this.renderDefaultFooter() : this.renderNotDefaultFooter(account) : null);
    }
  }, {
    key: "_renderAccountsCards",
    value: function _renderAccountsCards(accounts) {
      return repeat(_sortInstanceProperty(accounts).call(accounts, sortAccountsFn), function (a) {
        return a.linkedAccountId;
      }, this.renderAccountCard.bind(this));
    }
  }, {
    key: "_renderEditIcon",
    value: function _renderEditIcon(account) {
      return this.svg(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n    <svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      width=\"16\"\n      height=\"16\"\n      viewBox=\"0 0 24 24\"\n      @click=\"", "\">\n      <path d=\"M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z\"/>\n      <path d=\"M0 0h24v24H0z\" fill=\"none\"/>\n    </svg>"])), this.openEdit.bind(this, account));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-settings-linked-accounts';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        accounts: {
          type: Array,
          attribute: false,
          reflect: false
        },
        hideTitle: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        profile: {
          type: Object,
          attribute: false,
          reflect: false
        },
        profileType: {
          type: String,
          attribute: true,
          reflect: true
        },
        working: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        product: {
          type: String,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, bmButtonStyle, style$8];
    }
  }]);
  return BmSettingsLinkedAccounts;
}(alertsMixin(i18nMixin(BlueElement)));
var registerLinkedAccounts = function registerLinkedAccounts() {
  registerAlerts();
  registerModal();
  registerToggle();
  registerPopover();
  registerPageLayout();
  registerAccountDetail();
  registerLinkedAccountAdd();
  registerLinkedAccountsEdit();
  registerLanguage$4();
  register$1(BmSettingsLinkedAccounts);
};
function openLinkedAccountModal() {
  return _openLinkedAccountModal.apply(this, arguments);
}
function _openLinkedAccountModal() {
  _openLinkedAccountModal = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
    var product,
      _args7 = arguments;
    return _regeneratorRuntime.wrap(function _callee7$(_context16) {
      while (1) switch (_context16.prev = _context16.next) {
        case 0:
          product = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : 'onvio';
          return _context16.abrupt("return", new _Promise(function (resolve) {
            var onCancel = function onCancel() {
              removeModal();
              resolve();
            };
            var removeModal = createModal(html(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n        <bm-settings-linked-accounts product=\"", "\" hideTitle @cancel=\"", "\"></bm-settings-linked-accounts>\n      "])), product, onCancel), {
              title: 'linkedAccounts.title',
              size: 'large'
            });
          }));
        case 2:
        case "end":
          return _context16.stop();
      }
    }, _callee7);
  }));
  return _openLinkedAccountModal.apply(this, arguments);
}

var _templateObject$7, _templateObject2$7, _templateObject3$4, _templateObject4$4, _templateObject5$4;
var style$7 = css(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n  :host {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    contain: layout style;\n    max-height: 40px;\n    z-index: 100;\n    font-size: 14px;\n  }\n  :host > div {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n  }\n\n  :host([hidden]) {\n    display: none;\n  }\n\n  :host .current {\n    display: flex;\n    flex-direction: row;\n    flex-shrink: 0;\n    align-items: center;\n    transition: color ease-in-out 0.2s;\n  }\n\n  :host .current bm-linked-account-detail {\n    user-select: none;\n    align-items: flex-end;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 170px;\n  }\n\n  :host .current.dark {\n    color: #93939c;\n  }\n  :host .current.dark.multiple:hover {\n    color: #fff;\n  }\n\n  :host .current.light {\n    color: #212121;\n  }\n  :host .current.light.multiple:hover {\n    color: #93939c;\n  }\n\n  :host .current.multiple {\n    cursor: pointer;\n  }\n  :host .current.multiple::after {\n    content: '\\25BE';\n    padding-left: 10px;\n    font-size: 20px;\n  }\n  :host .accounts {\n    z-index: 101;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    min-height: 103px;\n    max-height: 500px;\n    overflow: overflow;\n    transform: translateX(32px);\n    overflow-y: scroll;\n  }\n\n  :host .accounts > bm-linked-account-detail {\n    user-select: none;\n    min-width: 220px;\n    padding: 10px 8px 8px;\n    cursor: pointer;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 170px;\n    flex-shrink: 0;\n    text-align: left;\n  }\n\n  :host .accounts > bm-linked-account-detail {\n    color: #000;\n  }\n\n  :host .accounts > bm-linked-account-detail:hover {\n    cursor: pointer;\n    background-color: #b5d6fd;\n  }\n\n  :host .accounts .header {\n    display: flex;\n    font-family: KnowledgeRegular, 'Helvetica Neue', Arial, sans-serif;\n    background-color: #f4f5f7;\n    padding: 10px 8px 8px;\n    color: #000;\n    align-items: center;\n    justify-content: space-between;\n    padding: 4px 8px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    height: 38px;\n    box-sizing: border-box;\n    top: 0px;\n    z-index: 10;\n    position: sticky;\n  }\n"], ["\n  :host {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    contain: layout style;\n    max-height: 40px;\n    z-index: 100;\n    font-size: 14px;\n  }\n  :host > div {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n  }\n\n  :host([hidden]) {\n    display: none;\n  }\n\n  :host .current {\n    display: flex;\n    flex-direction: row;\n    flex-shrink: 0;\n    align-items: center;\n    transition: color ease-in-out 0.2s;\n  }\n\n  :host .current bm-linked-account-detail {\n    user-select: none;\n    align-items: flex-end;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 170px;\n  }\n\n  :host .current.dark {\n    color: #93939c;\n  }\n  :host .current.dark.multiple:hover {\n    color: #fff;\n  }\n\n  :host .current.light {\n    color: #212121;\n  }\n  :host .current.light.multiple:hover {\n    color: #93939c;\n  }\n\n  :host .current.multiple {\n    cursor: pointer;\n  }\n  :host .current.multiple::after {\n    content: '\\\\25BE';\n    padding-left: 10px;\n    font-size: 20px;\n  }\n  :host .accounts {\n    z-index: 101;\n    background-color: #fff;\n    border: 1px solid rgba(0, 0, 0, 0.2);\n    min-height: 103px;\n    max-height: 500px;\n    overflow: overflow;\n    transform: translateX(32px);\n    overflow-y: scroll;\n  }\n\n  :host .accounts > bm-linked-account-detail {\n    user-select: none;\n    min-width: 220px;\n    padding: 10px 8px 8px;\n    cursor: pointer;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    max-width: 170px;\n    flex-shrink: 0;\n    text-align: left;\n  }\n\n  :host .accounts > bm-linked-account-detail {\n    color: #000;\n  }\n\n  :host .accounts > bm-linked-account-detail:hover {\n    cursor: pointer;\n    background-color: #b5d6fd;\n  }\n\n  :host .accounts .header {\n    display: flex;\n    font-family: KnowledgeRegular, 'Helvetica Neue', Arial, sans-serif;\n    background-color: #f4f5f7;\n    padding: 10px 8px 8px;\n    color: #000;\n    align-items: center;\n    justify-content: space-between;\n    padding: 4px 8px;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.15);\n    height: 38px;\n    box-sizing: border-box;\n    top: 0px;\n    z-index: 10;\n    position: sticky;\n  }\n"])));
var BmLinkedAccountSelector = /*#__PURE__*/function (_i18nMixin) {
  _inherits(BmLinkedAccountSelector, _i18nMixin);
  var _super = _createSuper(BmLinkedAccountSelector);
  function BmLinkedAccountSelector() {
    var _this;
    _classCallCheck(this, BmLinkedAccountSelector);
    _this = _super.call(this);
    _this.mode = 'light';
    _this.opened = false;
    _this.product = 'onvio';
    _this.accounts = [];
    _this.bindings = void 0;
    _this.commBus = void 0;
    _this.toogleList = _this.toogleList.bind(_assertThisInitialized(_this));
    _this.broadCastUpdate = _this.broadCastUpdate.bind(_assertThisInitialized(_this));
    _this.renderAccountItem = _this.renderAccountItem.bind(_assertThisInitialized(_this));
    _this.commBus = omnibus('linked-account');
    return _this;
  }
  _createClass(BmLinkedAccountSelector, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _get(_getPrototypeOf(BmLinkedAccountSelector.prototype), "connectedCallback", this).call(this);
              this.commBus.on('account-change', this.broadCastUpdate);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      _get(_getPrototypeOf(BmLinkedAccountSelector.prototype), "disconnectedCallback", this).call(this);
      this.commBus.nuke();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$accounts$find,
        _context2,
        _this2 = this,
        _context3,
        _ref,
        _current$displayedNic,
        _current$companyName;
      var current = (_this$accounts$find = _findInstanceProperty(_context2 = this.accounts).call(_context2, function (a) {
        return a.contactId === _this2.bindings.ApplicationConfiguration.ContactId;
      })) !== null && _this$accounts$find !== void 0 ? _this$accounts$find : {};
      var others = _filterInstanceProperty(_context3 = this.accounts).call(_context3, function (a) {
        return a.contactId !== _this2.bindings.ApplicationConfiguration.ContactId;
      });
      var multiple = others.length > 0;
      var currentWithTitle = _objectSpread(_objectSpread({}, current), {}, {
        title: ((_ref = (_current$displayedNic = current.displayedNickname) !== null && _current$displayedNic !== void 0 ? _current$displayedNic : current.accountName) !== null && _ref !== void 0 ? _ref : '') + '\r' + ((_current$companyName = current.companyName) !== null && _current$companyName !== void 0 ? _current$companyName : '')
      });
      var renderOptions = {
        mode: this.mode,
        multiple: multiple,
        current: currentWithTitle,
        opened: this.opened,
        others: others
      };
      return this.html(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteral(["\n      <div>\n        ", "\n        ", "\n        <bm-loading\n          ?active=\"", "\">\n        </bm-loading>\n      </div>\n    "])), this.renderBody(renderOptions), this.opened ? this.renderAccountsItems(others) : null, !this.bindings || this.accounts.length === 0);
    }
  }, {
    key: "firstUpdated",
    value: function () {
      var _firstUpdated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.updateData();
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee2, this);
      }));
      function firstUpdated() {
        return _firstUpdated.apply(this, arguments);
      }
      return firstUpdated;
    }()
  }, {
    key: "updateData",
    value: function () {
      var _updateData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _yield$Promise$all, _yield$Promise$all2, bindings, accounts;
        return _regeneratorRuntime.wrap(function _callee3$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 3;
              return _Promise.all([getBindings(), this.product === products.samba ? getActiveOnbalanceLinkedAccounts() : getActiveOnvioLinkedAccounts()]);
            case 3:
              _yield$Promise$all = _context5.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              bindings = _yield$Promise$all2[0];
              accounts = _yield$Promise$all2[1];
              this.bindings = bindings;
              this.accounts = accounts;
              _context5.next = 14;
              break;
            case 11:
              _context5.prev = 11;
              _context5.t0 = _context5["catch"](0);
              console.log(_context5.t0);
            case 14:
            case "end":
              return _context5.stop();
          }
        }, _callee3, this, [[0, 11]]);
      }));
      function updateData() {
        return _updateData.apply(this, arguments);
      }
      return updateData;
    }()
  }, {
    key: "broadCastUpdate",
    value: function broadCastUpdate(accounts) {
      var _this3 = this;
      if (accounts) {
        this.accounts = _filterInstanceProperty(accounts).call(accounts, function (account) {
          return account.active && account.primaryProduct === _this3.product;
        });
      } else {
        this.updateData();
      }
    }
  }, {
    key: "toogleList",
    value: function toogleList(event) {
      var _this4 = this;
      event.stopPropagation();
      this.opened = !this.opened;
      setTimeout(function () {
        if (_this4.opened) {
          document.addEventListener('click', _this4.toogleList);
        } else {
          document.removeEventListener('click', _this4.toogleList);
        }
      });
    }
  }, {
    key: "changeAccount",
    value: function () {
      var _changeAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(account) {
        var _account$linkedAccoun;
        var _yield$createWithLink, LongToken, SSOURL, event, redirectURL, newJWT, _event;
        return _regeneratorRuntime.wrap(function _callee4$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return createWithLinkedAccountId((_account$linkedAccoun = account.linkedAccountId) !== null && _account$linkedAccoun !== void 0 ? _account$linkedAccoun : '');
            case 2:
              _yield$createWithLink = _context6.sent;
              LongToken = _yield$createWithLink.LongToken;
              SSOURL = _yield$createWithLink.SSOURL;
              if (SSOURL) {
                event = new CustomEvent('switch', {
                  cancelable: true,
                  bubbles: false,
                  detail: {
                    SSOURL: SSOURL
                  }
                });
                this.dispatchEvent(event);
                if (!event.defaultPrevented) {
                  window.location.href = SSOURL;
                }
              }
              if (!LongToken) {
                _context6.next = 21;
                break;
              }
              if (!isLocalType) {
                _context6.next = 11;
                break;
              }
              _context6.t0 = new _URL(window.location.href).pathname;
              _context6.next = 14;
              break;
            case 11:
              _context6.next = 13;
              return switchAccountWithLongToken(LongToken);
            case 13:
              _context6.t0 = _context6.sent;
            case 14:
              redirectURL = _context6.t0;
              _context6.next = 17;
              return getJWTWithUDS(LongToken);
            case 17:
              newJWT = _context6.sent;
              _event = new CustomEvent('switch', {
                cancelable: true,
                bubbles: false,
                detail: {
                  jwt: newJWT,
                  uds: LongToken,
                  redirect: redirectURL
                }
              });
              this.dispatchEvent(_event);
              if (!_event.defaultPrevented) {
                store.jwt(newJWT);
                cookie('UDSLongToken', LongToken, '/');
                window.location.href = redirectURL;
              }
            case 21:
            case "end":
              return _context6.stop();
          }
        }, _callee4, this);
      }));
      function changeAccount(_x) {
        return _changeAccount.apply(this, arguments);
      }
      return changeAccount;
    }()
  }, {
    key: "managerAccounts",
    value: function managerAccounts() {
      openLinkedAccountModal(this.product);
    }
  }, {
    key: "renderAccountItem",
    value: function renderAccountItem(account) {
      return this.html(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteral(["<bm-linked-account-detail\n      @click=\"", "\"\n      .account=\"", "\"/>"])), this.changeAccount.bind(this, account), account);
    }
  }, {
    key: "renderAccountsItems",
    value: function renderAccountsItems(accounts) {
      var _this5 = this;
      return this.html(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteral(["<div class=\"accounts\">\n      <div class=\"header\">\n        ", "\n        <button class=\"bm-button link\" @click=\"", "\">\n          ", "\n        </button>\n      </div>\n      ", "\n    </div>"])), this.i18n('linkedAccounts.title'), function () {
        return _this5.managerAccounts();
      }, this.i18n('common.manage'), repeat(accounts, function (a) {
        return a.linkedAccountId;
      }, this.renderAccountItem));
    }
  }, {
    key: "renderBody",
    value: function renderBody(opts) {
      return this.html(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteral(["\n        <div\n          class=\"current ", " ", "\"\n          title=\"", "\"\n          @click=\"", "\">\n          <bm-linked-account-detail .account=\"", "\"></bm-linked-account-detail>\n        </div>\n    "])), opts.mode, opts.multiple ? 'multiple' : '', opts.current.title, opts.multiple ? this.toogleList : null, opts.current);
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-linked-account-selector';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        accounts: {
          type: Array,
          attribute: false,
          reflect: false
        },
        mode: {
          type: String,
          attribute: true,
          reflect: true
        },
        opened: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        bindings: {
          type: Object,
          attribute: false,
          reflect: false
        },
        product: {
          type: String,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, bmButtonStyle, style$7];
    }
  }]);
  return BmLinkedAccountSelector;
}(i18nMixin(BlueElement));
var registerAccountSelector = function registerAccountSelector() {
  registerLanguage$4();
  registerAccountDetail();
  registerLinkedAccounts();
  registerLoading();
  register$1(BmLinkedAccountSelector);
};

var enUS$1 = {
  "menu.profile": "Profile",
  "menu.account.information": "Account Information",
  "menu.password": "Password",
  "menu.mfa": "Multi-factor Authentication",
  "menu.linked.accounts": "Linked Accounts",
  "menu.preferences": "Preferences",
  "menu.onvio.center": "Onvio Center",
  "menu.time.and.billing": "Time and Billing"
};
var esAR$1 = {
  "menu.profile": "Perfil",
  "menu.account.information": "Informaci\xF3n de la Cuenta",
  "menu.password": "Contrase\xF1a",
  "menu.mfa": "Autenticaci\xF3n de M\xFAltiples Factores",
  "menu.linked.accounts": "Cuentas Vinculadas",
  "menu.preferences": "Preferencias",
  "menu.onvio.center": "Portal Onvio",
  "menu.time.and.billing": "Honorarios"
};
var ptBR$1 = {
  "menu.profile": "Perfil",
  "menu.account.information": "Informa\xE7\xE3o da conta",
  "menu.password": "Senha",
  "menu.mfa": "Autentica\xE7\xE3o de Multi-Fatores",
  "menu.linked.accounts": "Contas vinculadas",
  "menu.preferences": "Prefer\xEAncias",
  "menu.onvio.center": "Onvio Gest\xE3o",
  "menu.time.and.billing": "Tempo e Faturamento"
};
var frCA$1 = {
  "menu.profile": "Profil",
  "menu.account.information": "Renseignements sur le compte",
  "menu.password": "Mot de passe",
  "menu.mfa": "Authentification multifacteurs",
  "menu.linked.accounts": "Comptes li\xE9s",
  "menu.preferences": "Pr\xE9f\xE9rences",
  "menu.onvio.center": "Onvio Centre",
  "menu.time.and.billing": "Gestion temps et facturation"
};
var registerLanguage$1 = (function () {
  registerCommon();
  addKeys(enUS$1, 'en-US');
  addKeys(esAR$1, 'es-AR');
  addKeys(ptBR$1, 'pt-BR');
  addKeys(frCA$1, 'fr-CA');
});

var _templateObject$6, _templateObject2$6, _templateObject3$3, _templateObject4$3, _templateObject5$3;
function filterWithBindings(_x) {
  return _filterWithBindings.apply(this, arguments);
}
function _filterWithBindings() {
  _filterWithBindings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(items) {
    var filtered;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return filterAsync(items, /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(item) {
              var add;
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    add = true;
                    if (!(item.frps && item.frps.length > 0)) {
                      _context2.next = 8;
                      break;
                    }
                    _context2.t0 = add;
                    if (!_context2.t0) {
                      _context2.next = 7;
                      break;
                    }
                    _context2.next = 6;
                    return has$1(item.frps, true);
                  case 6:
                    _context2.t0 = _context2.sent;
                  case 7:
                    add = _context2.t0;
                  case 8:
                    if (!(item.iacs && item.iacs.length > 0)) {
                      _context2.next = 15;
                      break;
                    }
                    _context2.t1 = add;
                    if (!_context2.t1) {
                      _context2.next = 14;
                      break;
                    }
                    _context2.next = 13;
                    return has(item.iacs, true);
                  case 13:
                    _context2.t1 = _context2.sent;
                  case 14:
                    add = _context2.t1;
                  case 15:
                    return _context2.abrupt("return", add);
                  case 16:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            }));
            return function (_x3) {
              return _ref.apply(this, arguments);
            };
          }());
        case 2:
          filtered = _context4.sent;
          return _context4.abrupt("return", _Promise.all(_mapInstanceProperty(filtered).call(filtered, /*#__PURE__*/function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(item) {
              var newItem;
              return _regeneratorRuntime.wrap(function _callee3$(_context3) {
                while (1) switch (_context3.prev = _context3.next) {
                  case 0:
                    newItem = _objectSpread({}, item);
                    if (!(item.items && item.items.length > 0)) {
                      _context3.next = 5;
                      break;
                    }
                    _context3.next = 4;
                    return filterWithBindings(item.items);
                  case 4:
                    newItem.items = _context3.sent;
                  case 5:
                    return _context3.abrupt("return", newItem);
                  case 6:
                  case "end":
                    return _context3.stop();
                }
              }, _callee3);
            }));
            return function (_x4) {
              return _ref2.apply(this, arguments);
            };
          }())));
        case 4:
        case "end":
          return _context4.stop();
      }
    }, _callee4);
  }));
  return _filterWithBindings.apply(this, arguments);
}
var menuItems = [{
  code: 'profile',
  items: [{
    code: 'account-information',
    translate: 'menu.account.information'
  }, {
    code: 'password',
    translate: 'menu.password',
    iacs: ['Platform_DisableAuth0Phase2']
  }, {
    code: 'mfa',
    translate: 'menu.mfa',
    iacs: ['Platform_Enable2FA', 'Platform_DisableAuth0Phase2']
  }, {
    code: 'linked-accounts',
    translate: 'menu.linked.accounts',
    iacs: ['PPE-AccountSwitching']
  }],
  translate: 'menu.profile'
}];
var menuOpenMediaQuery = window.matchMedia('(min-width: 700px)');
var style$6 = css(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n  :host {\n    display: inline-flex;\n    contain: content;\n    font-family: KnowledgeRegular, 'Helvetica Neue', Arial, sans-serif;\n    overflow: hidden;\n    --menu-ul-max-width: 1000px;\n    font-size: 14px;\n  }\n\n  :host([hidden]) {\n    display: none;\n  }\n\n  :host > ul.close {\n    max-width: 0px;\n  }\n\n  :host > ul:not(.close) {\n    border-right: solid 1px #e4e4e5;\n  }\n\n  :host ul {\n    padding: 0;\n    margin: 0;\n    font-size: 1em;\n    font-family: KnowledgeRegular, 'Helvetica Neue', Arial, sans-serif;\n  }\n\n  :host > ul {\n    transition: max-width 1s;\n    overflow: hidden;\n    max-width: 400px;\n    max-width: var(--menu-ul-max-width);\n    margin-top: 0.5em;\n  }\n\n  :host li {\n    font-style: normal;\n    font-size: 1.1em;\n    color: #212121;\n    min-height: 40px;\n    vertical-align: middle;\n    line-height: 40px;\n    text-decoration: none;\n    list-style: none;\n    padding-left: 25px;\n    padding-right: 15px;\n    font-size: 1em;\n    font-family: KnowledgeRegular, 'Helvetica Neue', Arial, sans-serif;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n  :host li:not(.no-leaf) {\n    cursor: pointer;\n  }\n\n  :host li.no-leaf {\n    font-size: 1.3em;\n    font-family: KnowledgeMedium, 'Helvetica Neue', Arial, sans-serif;\n  }\n\n  :host li.active {\n    border-left: solid 6px #ff8000;\n    border-color: #ff8000;\n    border-color: var(--accent-color, #ff8000);\n    background-color: #f4f5f7;\n    padding-left: 20px;\n  }\n\n  :host > ul > li {\n    padding: 0;\n  }\n\n  :host li:not(.no-leaf):hover {\n    background-color: #f4f5f7;\n  }\n\n  @media (min-width: 700px) {\n    :host .open-menu-button {\n      display: none;\n    }\n    :host > ul {\n      transition: none;\n      max-width: unset;\n    }\n  }\n"])));
var BmSettingsMenu = /*#__PURE__*/function (_i18nMixin) {
  _inherits(BmSettingsMenu, _i18nMixin);
  var _super = _createSuper(BmSettingsMenu);
  function BmSettingsMenu() {
    var _this;
    _classCallCheck(this, BmSettingsMenu);
    _this = _super.call(this);
    _this.active = '';
    _this.isMenuOpen = false;
    _this.showMenu = false;
    _this.showMenu = menuOpenMediaQuery.matches;
    _this.onMediaQueryChange = _this.onMediaQueryChange.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(BmSettingsMenu, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      _get(_getPrototypeOf(BmSettingsMenu.prototype), "connectedCallback", this).call(this);
      menuOpenMediaQuery.addListener(this.onMediaQueryChange);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      _get(_getPrototypeOf(BmSettingsMenu.prototype), "disconnectedCallback", this).call(this);
      menuOpenMediaQuery.removeListener(this.onMediaQueryChange);
    }
  }, {
    key: "updated",
    value: function updated(changedProperties) {
      _get(_getPrototypeOf(BmSettingsMenu.prototype), "updated", this).call(this, changedProperties);
      if (this.style.setProperty) {
        var _this$shadowRoot;
        var rootUL = ((_this$shadowRoot = this.shadowRoot) !== null && _this$shadowRoot !== void 0 ? _this$shadowRoot : this).querySelector('ul');
        if (rootUL) {
          this.style.setProperty('--menu-ul-max-width', "".concat(rootUL.scrollWidth + 30, "px"));
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.html(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral(["\n      <div class=\"open-menu-button\">\n        ", "\n      </div>\n      <ul class=\"", "\">\n        ", "\n      </ul>\n    "])), this.isMenuOpen ? null : this._renderMenuIcon(), this.isMenuOpen || this.showMenu ? '' : 'close', until(this._renderItems(menuItems)));
    }
  }, {
    key: "onMediaQueryChange",
    value: function onMediaQueryChange(event) {
      if (event.matches) {
        this.showMenu = true;
      } else {
        this.showMenu = this.isMenuOpen;
      }
    }
  }, {
    key: "toggleMenu",
    value: function toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    }
  }, {
    key: "_renderItems",
    value: function () {
      var _renderItems2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(items) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = repeat;
              _context.next = 3;
              return filterWithBindings(items);
            case 3:
              _context.t1 = _context.sent;
              _context.t2 = function (i) {
                return i.code;
              };
              _context.t3 = this._renderItem.bind(this);
              return _context.abrupt("return", (0, _context.t0)(_context.t1, _context.t2, _context.t3));
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function _renderItems(_x2) {
        return _renderItems2.apply(this, arguments);
      }
      return _renderItems;
    }()
  }, {
    key: "_renderItem",
    value: function _renderItem(item) {
      var className = item.items ? 'no-leaf' : '';
      className += item.code === this.active ? 'active' : '';
      var click = this._updateActiveSection.bind(this, item.code);
      return this.html(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteral(["\n    <li\n      class=\"", "\"\n      @click=\"", "\"\n      data-qe-id=\"id-", "\"\n      >\n      <span>", "</span>\n      ", "\n    </li>"])), className, item.items ? null : click, item.code, this.i18n(item.translate), item.items && this.html(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteral(["<ul>", "</ul>"])), until(this._renderItems(item.items))));
    }
  }, {
    key: "_updateActiveSection",
    value: function _updateActiveSection(code) {
      this.toggleMenu();
      this.active = code;
      this.dispatchEvent(new CustomEvent('active-change', {
        detail: code
      }));
    }
  }, {
    key: "_renderMenuIcon",
    value: function _renderMenuIcon() {
      return this.svg(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteral(["<svg\n      xmlns=\"http://www.w3.org/2000/svg\"\n      @click=\"", "\"\n      width=\"24\"\n      height=\"24\"\n      viewBox=\"0 0 24 24\">\n      <path d=\"M0 0h24v24H0z\" fill=\"none\"/>\n      <path d=\"M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z\"/>\n    </svg>"])), this.toggleMenu.bind(this));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-settings-menu';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        active: {
          type: String,
          attribute: true,
          reflect: true
        },
        isMenuOpen: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        showMenu: {
          type: Boolean,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix$1, style$6];
    }
  }]);
  return BmSettingsMenu;
}(i18nMixin(BlueElement));
var registerMenu = function registerMenu() {
  registerLanguage$1();
  register$1(BmSettingsMenu);
};

var enUS = {
  "mfa.title": "Multi-Factor Authentication",
  "mfa.description": "Multi-Factor authentication is <strong>{{var}}</strong> for your account.",
  "mfa.noFactors": "Your account is not associated with any devices.",
  "mfa.learnMode": "Learn more about Multi-Factor Authentication",
  "mfa.optionsDesc": "You have set up the following multi-factor options.",
  "mfa.setDefault": "Set As Default",
  "mfa.addFactor": "Add option",
  "mfa.emergencyCodes": "Emergency Access Codes",
  "mfa.emergencyCodesDesc": "If you lose access to your device, you can use an emergency access code to sign in to your account. Each code may be used only once. Generating new codes will replace codes that you have generated previously.",
  "mfa.genEmergencyCodes": "Generate New Codes",
  "mfa.remove": "Remove device"
};
var esAR = {
  "mfa.title": "Autenticaci\xF3n de M\xFAltiples Factores",
  "mfa.description": "La autenticaci\xF3n de M\xFAltiples Factores es <strong>{{var}}</strong> para su cuenta.",
  "mfa.noFactors": "Su cuenta no est\xE1 asociada a ning\xFAn dispositivo.",
  "mfa.learnMode": "Obtenga m\xE1s informaci\xF3n sobre la Autenticaci\xF3n de M\xFAltiples Factores",
  "mfa.optionsDesc": "Ha configurado las siguientes opciones de M\xFAltiples Factores.",
  "mfa.setDefault": "Establecer como Predeterminado",
  "mfa.addFactor": "A\xF1adir opci\xF3n",
  "mfa.emergencyCodes": "C\xF3digos de Acceso de Emergencia",
  "mfa.emergencyCodesDesc": "Si pierde el acceso a su dispositivo, puede usar un c\xF3digo de acceso de emergencia para iniciar sesi\xF3n en su cuenta. Cada c\xF3digo se puede usar solo una vez. La generaci\xF3n de nuevos c\xF3digos reemplazar\xE1 los c\xF3digos que haya generado anteriormente.",
  "mfa.genEmergencyCodes": "Generar nuevos c\xF3digos",
  "mfa.remove": "Eliminar Dispositivo"
};
var ptBR = {
  "mfa.title": "Autentica\xE7\xE3o de Multi-Fatores",
  "mfa.description": "A autentica\xE7\xE3o multi-fator \xE9 <strong>{{var}}</strong> para sua conta.",
  "mfa.noFactors": "A sua conta n\xE3o est\xE1 associada a nenhum dispositivo.",
  "mfa.learnMode": "Saiba mais sobre a Autentica\xE7\xE3o Multi-Fatores",
  "mfa.optionsDesc": "Voc\xEA configurou as seguintes op\xE7\xF5es de multi-fatores.",
  "mfa.setDefault": "Definir como padr\xE3o",
  "mfa.addFactor": "Adicionar op\xE7\xE3o",
  "mfa.emergencyCodes": "C\xF3digos de acesso de emerg\xEAncia",
  "mfa.emergencyCodesDesc": "Se voc\xEA perder o acesso ao seu dispositivo, poder\xE1 usar um c\xF3digo de acesso de emerg\xEAncia para fazer login na sua conta. Cada c\xF3digo pode ser usado apenas uma vez. A gera\xE7\xE3o de novos c\xF3digos substituir\xE1 os c\xF3digos que voc\xEA gerou anteriormente.",
  "mfa.genEmergencyCodes": "Gerar novos c\xF3digos",
  "mfa.remove": "Remover dispositivo"
};
var frCA = {
  "mfa.title": "Authentification multifacteurs",
  "mfa.description": "L\u2019authentification multifacteurs est <strong>{{var}}</strong> pour votre compte.",
  "mfa.noFactors": "Votre compte n'est associ\xE9 \xE0 aucun appareil.",
  "mfa.learnMode": "En apprendre davantage sur l\u2019authentification multifacteurs",
  "mfa.optionsDesc": "Vous avez configur\xE9 les options multifacteurs suivantes.",
  "mfa.setDefault": "D\xE9finir comme option par d\xE9faut",
  "mfa.addFactor": "Ajouter une option",
  "mfa.emergencyCodes": "Codes d'acc\xE8s d'urgence",
  "mfa.emergencyCodesDesc": "Si vous perdez l'acc\xE8s \xE0 votre appareil, vous pouvez utiliser un code d'acc\xE8s d'urgence pour vous connecter \xE0 votre compte. Chaque code ne peut \xEAtre utilis\xE9 qu'une seule fois. Les nouveaux codes g\xE9n\xE9r\xE9s remplaceront les codes que vous avez g\xE9n\xE9r\xE9s pr\xE9c\xE9demment.",
  "mfa.genEmergencyCodes": "G\xE9n\xE9rer de nouveaux codes",
  "mfa.remove": "Supprimer l'appareil"
};
var registerLanguage = (function () {
  registerCommon();
  addKeys(enUS, 'en-US');
  addKeys(esAR, 'es-AR');
  addKeys(ptBR, 'pt-BR');
  addKeys(frCA, 'fr-CA');
});

var _templateObject$5, _templateObject2$5, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$1;
function normalizeLanguageCodeForHelp(lang) {
  var _context, _context2, _context3;
  if (lang.length > 4) {
    return lang.toLowerCase().split('-').reverse().join('-');
  }
  var _lang$toLowerCase = lang.toLowerCase(),
    _lang$toLowerCase2 = _slicedToArray(_lang$toLowerCase, 4),
    c1 = _lang$toLowerCase2[0],
    c2 = _lang$toLowerCase2[1],
    l1 = _lang$toLowerCase2[2],
    l2 = _lang$toLowerCase2[3];
  return _concatInstanceProperty(_context = _concatInstanceProperty(_context2 = _concatInstanceProperty(_context3 = "".concat(l1)).call(_context3, l2, "-")).call(_context2, c1)).call(_context, c2);
}
var style$5 = css(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n  :host {\n    display: flex;\n    contain: content;\n    color: #434343;\n    font-family: Arial, 'Helvetica Neue', sans-serif;\n    font-size: 14px;\n  }\n  :host([hidden]) {\n    display: none;\n  }\n\n  :host h3 {\n    font-weight: 400;\n    font-style: normal;\n    color: #666666;\n    font-family: KnowledgeRegular, 'Helvetica Neue', Arial, sans-serif;\n  }\n  :host h4 {\n    font-weight: 400;\n    font-style: normal;\n    color: #434343;\n  }\n\n  :host p {\n    margin-top: 0;\n  }\n\n  :host .bm-container {\n    display: flex;\n    flex-direction: column;\n    align-items: start;\n    margin-bottom: 20px;\n  }\n\n  :host .factors {\n    padding-left: 20px;\n    margin: 0;\n    margin-bottom: 1.33em;\n  }\n  :host .factors > div {\n    display: -ms-grid;\n    display: grid;\n    -ms-grid-columns: auto 30px;\n    grid-template-columns: auto 30px;\n    grid-auto-rows: 30px;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    align-items: center;\n    grid-column-gap: 10px;\n  }\n  :host .factors > div svg {\n    cursor: pointer;\n  }\n\n  /*\n    This is to override when ShadyCSS doesn't work correctly in IE11\n    TODO: Remove when all supported browser have ShadowDOM\n  */\n  :host svg {\n    animation-name: none;\n    height: 24px;\n    width: 24px;\n  }\n"])));
var BmSettingsMFA = /*#__PURE__*/function (_alertsMixin) {
  _inherits(BmSettingsMFA, _alertsMixin);
  var _super = _createSuper(BmSettingsMFA);
  function BmSettingsMFA() {
    var _context4;
    var _this;
    _classCallCheck(this, BmSettingsMFA);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, _concatInstanceProperty(_context4 = [this]).call(_context4, args));
    _this.mode = void 0;
    _this.factors = [];
    _this.required = false;
    _this.user = {};
    _this.working = false;
    _this.isClient = false;
    return _this;
  }
  _createClass(BmSettingsMFA, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, required, user;
        return _regeneratorRuntime.wrap(function _callee$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _get(_getPrototypeOf(BmSettingsMFA.prototype), "connectedCallback", this).call(this);
              this.working = true;
              _context5.prev = 2;
              _context5.next = 5;
              return _Promise.all([userRequired(), getCurrentUser(), this.loadFactors(), this.defineIfIsClient()]);
            case 5:
              _yield$Promise$all = _context5.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              required = _yield$Promise$all2[0];
              user = _yield$Promise$all2[1];
              this.required = required;
              this.user = user;
              _context5.next = 16;
              break;
            case 13:
              _context5.prev = 13;
              _context5.t0 = _context5["catch"](2);
              this.replaceAlerts(normalizeError(_context5.t0), 'danger');
            case 16:
              _context5.prev = 16;
              this.working = false;
              return _context5.finish(16);
            case 19:
            case "end":
              return _context5.stop();
          }
        }, _callee, this, [[2, 13, 16, 19]]);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "render",
    value: function render() {
      var _context6,
        _this2 = this;
      var reqOpt = instantTranslate(this.required ? 'common.required' : 'common.optional');
      var helpLangCode = normalizeLanguageCodeForHelp(getCurrentLanguage(true));
      var helpLink = _concatInstanceProperty(_context6 = "/ua/help/".concat(helpLangCode, "/")).call(_context6, this.isClient ? 'client' : 'staff', "/core/common/mfa-overview.htm");
      var hasFactor = this.factors.length > 0;
      var factorsUI = repeat(this.factors, function (i) {
        return i.id;
      }, function (f) {
        return _this2.renderFactor(f);
      });
      return this.html(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n      <bm-settings-page-layout\n        hideSave\n        label=\"", "\">\n        <bm-alerts></bm-alerts>\n        <div class=\"bm-container\">\n          <span>\n            ", "\n            <a\n              class=\"bm-button link external\"\n              data-qe-id=\"help-link-mfa\"\n              target=\"_blank\"\n              href=\"", "\">\n              ", "\n            </a>\n          </span>\n\n          <h3>", "</h3>\n\n          ", "\n          ", "\n\n          <div class=\"factors\">", "</div>\n          <button\n            class=\"bm-button link\"\n            data-qe-id=\"add-option\"\n            @click=\"", "\">\n            ", "\n          </button>\n\n          ", "\n        </div>\n      </bm-settings-page-layout>\n      <bm-loading ?active=\"", "\"></bm-loading>\n    "])), this.i18n('mfa.title'), this.i18nHTML('mfa.description', {
        var: reqOpt
      }), helpLink, this.i18n('mfa.learnMode'), this.i18n('common.options'), hasFactor ? null : this.translatedP('mfa.optionsDesc'), hasFactor ? null : this.translatedP('mfa.noFactors'), factorsUI, this.onAddFactor.bind(this), this.i18n('mfa.addFactor'), hasFactor ? this.renderEnergencyCode() : null, this.working);
    }
  }, {
    key: "loadFactors",
    value: function () {
      var _loadFactors = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var factors;
        return _regeneratorRuntime.wrap(function _callee2$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _context7.next = 2;
              return getFactors();
            case 2:
              factors = _context7.sent;
              this.factors = _filterInstanceProperty(factors).call(factors, function (factor) {
                return factor.type !== 'B' && factor.type !== 'C';
              });
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee2, this);
      }));
      function loadFactors() {
        return _loadFactors.apply(this, arguments);
      }
      return loadFactors;
    }()
  }, {
    key: "defineIfIsClient",
    value: function () {
      var _defineIfIsClient = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!this.mode) {
                _context8.next = 4;
                break;
              }
              this.isClient = this.mode === 'client';
              _context8.next = 7;
              break;
            case 4:
              _context8.next = 6;
              return has$1('Platform.DefaultClient');
            case 6:
              this.isClient = _context8.sent;
            case 7:
            case "end":
              return _context8.stop();
          }
        }, _callee3, this);
      }));
      function defineIfIsClient() {
        return _defineIfIsClient.apply(this, arguments);
      }
      return defineIfIsClient;
    }()
  }, {
    key: "validatePassword",
    value: function () {
      var _validatePassword = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        return _regeneratorRuntime.wrap(function _callee4$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              if (!(this.user && this.user.email)) {
                _context9.next = 2;
                break;
              }
              return _context9.abrupt("return", checkPassword({
                email: this.user.email
              }));
            case 2:
              return _context9.abrupt("return", false);
            case 3:
            case "end":
              return _context9.stop();
          }
        }, _callee4, this);
      }));
      function validatePassword() {
        return _validatePassword.apply(this, arguments);
      }
      return validatePassword;
    }()
  }, {
    key: "onGenerateCodes",
    value: function () {
      var _onGenerateCodes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _this$user$language;
        return _regeneratorRuntime.wrap(function _callee5$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.t0 = !this.user || !this.user.email;
              if (_context10.t0) {
                _context10.next = 5;
                break;
              }
              _context10.next = 4;
              return this.validatePassword();
            case 4:
              _context10.t0 = !_context10.sent;
            case 5:
              if (!_context10.t0) {
                _context10.next = 7;
                break;
              }
              return _context10.abrupt("return");
            case 7:
              _context10.prev = 7;
              _context10.next = 10;
              return initEmergencyCodesSetup(this.user.email, (_this$user$language = this.user.language) !== null && _this$user$language !== void 0 ? _this$user$language : 'en-US');
            case 10:
              _context10.next = 15;
              break;
            case 12:
              _context10.prev = 12;
              _context10.t1 = _context10["catch"](7);
              this.replaceAlerts(normalizeError(_context10.t1), 'danger');
            case 15:
              _context10.prev = 15;
              this.working = false;
              return _context10.finish(15);
            case 18:
            case "end":
              return _context10.stop();
          }
        }, _callee5, this, [[7, 12, 15, 18]]);
      }));
      function onGenerateCodes() {
        return _onGenerateCodes.apply(this, arguments);
      }
      return onGenerateCodes;
    }()
  }, {
    key: "onAddFactor",
    value: function () {
      var _onAddFactor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this$user$language2, result;
        return _regeneratorRuntime.wrap(function _callee6$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              _context11.t0 = !this.user || !this.user.email;
              if (_context11.t0) {
                _context11.next = 5;
                break;
              }
              _context11.next = 4;
              return this.validatePassword();
            case 4:
              _context11.t0 = !_context11.sent;
            case 5:
              if (!_context11.t0) {
                _context11.next = 7;
                break;
              }
              return _context11.abrupt("return");
            case 7:
              _context11.prev = 7;
              _context11.next = 10;
              return initFactorSetup(this.user.email, (_this$user$language2 = this.user.language) !== null && _this$user$language2 !== void 0 ? _this$user$language2 : 'en-US');
            case 10:
              result = _context11.sent;
              if (!result) {
                _context11.next = 15;
                break;
              }
              this.working = true;
              _context11.next = 15;
              return this.loadFactors();
            case 15:
              _context11.next = 20;
              break;
            case 17:
              _context11.prev = 17;
              _context11.t1 = _context11["catch"](7);
              this.replaceAlerts(normalizeError(_context11.t1), 'danger');
            case 20:
              _context11.prev = 20;
              this.working = false;
              return _context11.finish(20);
            case 23:
            case "end":
              return _context11.stop();
          }
        }, _callee6, this, [[7, 17, 20, 23]]);
      }));
      function onAddFactor() {
        return _onAddFactor.apply(this, arguments);
      }
      return onAddFactor;
    }()
  }, {
    key: "onDeleteFactor",
    value: function () {
      var _onDeleteFactor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(factor) {
        return _regeneratorRuntime.wrap(function _callee7$(_context12) {
          while (1) switch (_context12.prev = _context12.next) {
            case 0:
              _context12.t0 = !this.user || !this.user.email;
              if (_context12.t0) {
                _context12.next = 5;
                break;
              }
              _context12.next = 4;
              return this.validatePassword();
            case 4:
              _context12.t0 = !_context12.sent;
            case 5:
              if (!_context12.t0) {
                _context12.next = 7;
                break;
              }
              return _context12.abrupt("return");
            case 7:
              this.working = true;
              _context12.prev = 8;
              _context12.next = 11;
              return deleteFactor(factor);
            case 11:
              _context12.next = 13;
              return this.loadFactors();
            case 13:
              _context12.next = 18;
              break;
            case 15:
              _context12.prev = 15;
              _context12.t1 = _context12["catch"](8);
              this.replaceAlerts(normalizeError(_context12.t1), 'danger');
            case 18:
              _context12.prev = 18;
              this.working = false;
              return _context12.finish(18);
            case 21:
            case "end":
              return _context12.stop();
          }
        }, _callee7, this, [[8, 15, 18, 21]]);
      }));
      function onDeleteFactor(_x) {
        return _onDeleteFactor.apply(this, arguments);
      }
      return onDeleteFactor;
    }()
  }, {
    key: "renderDeleteIcon",
    value: function renderDeleteIcon(factor) {
      return this.svg(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral(["\n      <svg\n        title=\"", "\"\n        xmlns=\"http://www.w3.org/2000/svg\"\n        @click=\"", "\"\n        width=\"24\" height=\"24\" viewBox=\"0 0 24 24\">\n        <path d=\"M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z\"/>\n        <path d=\"M0 0h24v24H0z\" fill=\"none\"/>\n      </svg>"])), this.i18n('mfa.remove'), this.onDeleteFactor.bind(this, factor));
    }
  }, {
    key: "renderFactor",
    value: function renderFactor(factor) {
      var cantDelete = this.required && this.factors.length < 2;
      return this.html(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteral(["<div>\n      <span>\n        ", "\n      </span>\n      ", "\n    </div>"])), factor.name, cantDelete ? null : this.renderDeleteIcon(factor));
    }
  }, {
    key: "renderEnergencyCode",
    value: function renderEnergencyCode() {
      return this.html(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteral(["\n      <h3>", "</h3>\n      <p>", "</p>\n      <button\n        class=\"bm-button outline primary\"\n        @click=\"", "\">\n        ", "\n      </button>\n    "])), this.i18n('mfa.emergencyCodes'), this.i18n('mfa.emergencyCodesDesc'), this.onGenerateCodes.bind(this), this.i18n('mfa.genEmergencyCodes'));
    }
  }, {
    key: "translatedP",
    value: function translatedP(key) {
      return this.html(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteral(["<p>", "</p>"])), this.i18n(key));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-settings-mfa';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        isClient: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        mode: {
          type: String,
          attribute: true,
          reflect: true
        },
        factors: {
          type: Array,
          attribute: false,
          reflect: false
        },
        required: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        user: {
          type: Object,
          attribute: false,
          reflect: false
        },
        working: {
          type: Boolean,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, bmButtonStyle, bmInputStyle, style$5];
    }
  }]);
  return BmSettingsMFA;
}(alertsMixin(i18nMixin(BlueElement)));
var registerMFA = function registerMFA() {
  registerLanguage();
  registerAlerts();
  registerLoading();
  registerPageLayout();
  registerPasswordCheck();
  register$1(BmSettingsMFA);
};

var _templateObject$4, _templateObject2$4, _templateObject3$1, _templateObject4$1, _templateObject5$1;
var style$4 = css(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n  :host {\n    display: flex;\n    contain: content;\n    flex-direction: column;\n    font-size: 14px;\n  }\n  :host([hidden]) {\n    display: none;\n  }\n    :host .bm-container {\n    min-width:180px;\n    border: none;\n    padding: 9px 14px;\n    text-align:start;\n    margin 5px 0 10px 0;\n    font-size:16px;\n    font-family:KnowledgeRegular;\n  }\n\n  :host([onbalance]) .bm-container {\n    font-family:KnowledgeLight;\n  }\n\n  :host ul {\n    padding-left: 20px;\n  }\n\n  :host li {\n    list-style-type: none;\n    margin-left: -18px;\n    margin-bottom: 2px;\n    display: flex;\n  }\n\n  :host li svg {\n    height: 16px;\n  }\n\n  :host li.passing {\n    color: #090;\n    fill: #090;\n  }\n\n  :host li.failing {\n    color: #999;\n    fill: #999;\n    color: default;\n  }\n\n  :host h3 {\n    font-family: 'KnowledgeBold', 'Helvetica Neue', sans-serif;\n    font-size: 1em;\n    background-color: #f4f5f7;\n    color: #797979;\n    padding: 10px 15px;\n    margin: 0;\n    border: 1px solid #999;\n    border-bottom: 0;\n  }\n"])));
var BmSettingsPasswordValidation = /*#__PURE__*/function (_i18nMixin) {
  _inherits(BmSettingsPasswordValidation, _i18nMixin);
  var _super = _createSuper(BmSettingsPasswordValidation);
  function BmSettingsPasswordValidation() {
    var _context;
    var _this;
    _classCallCheck(this, BmSettingsPasswordValidation);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, _concatInstanceProperty(_context = [this]).call(_context, args));
    _this.password = '';
    _this.rules = void 0;
    return _this;
  }
  _createClass(BmSettingsPasswordValidation, [{
    key: "render",
    value: function render() {
      return this.html(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n      ", "\n    "])), this.rules ? this.renderValidator(this.password, this.rules) : null);
    }
  }, {
    key: "renderRule",
    value: function () {
      var _renderRule = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(rule, pass) {
        var className;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _Promise.resolve(pass);
            case 2:
              if (!_context2.sent) {
                _context2.next = 6;
                break;
              }
              _context2.t0 = 'passing';
              _context2.next = 7;
              break;
            case 6:
              _context2.t0 = 'failing';
            case 7:
              className = _context2.t0;
              return _context2.abrupt("return", this.html(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["<li\n      class=\"", "\">\n      <div>", "</div>\n      <div>", "</div>\n    </li>"])), className, className === 'passing' ? checkmark : closeX, this.i18n(rule.label, rule.interpolation)));
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee, this);
      }));
      function renderRule(_x, _x2) {
        return _renderRule.apply(this, arguments);
      }
      return renderRule;
    }()
  }, {
    key: "reduceRulesSync",
    value: function reduceRulesSync(rules, password) {
      return rules.reduce(function (out, r) {
        return out && r.test(password);
      }, true);
    }
  }, {
    key: "reduceRulesAsync",
    value: function () {
      var _reduceRulesAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(rules, password) {
        var results;
        return _regeneratorRuntime.wrap(function _callee3$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return _Promise.all(_mapInstanceProperty(rules).call(rules, /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(r) {
                  return _regeneratorRuntime.wrap(function _callee2$(_context3) {
                    while (1) switch (_context3.prev = _context3.next) {
                      case 0:
                        return _context3.abrupt("return", r.test(password));
                      case 1:
                      case "end":
                        return _context3.stop();
                    }
                  }, _callee2);
                }));
                return function (_x5) {
                  return _ref.apply(this, arguments);
                };
              }()));
            case 2:
              results = _context4.sent;
              return _context4.abrupt("return", results.reduce(function (out, r) {
                return out && r;
              }, true));
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee3);
      }));
      function reduceRulesAsync(_x3, _x4) {
        return _reduceRulesAsync.apply(this, arguments);
      }
      return reduceRulesAsync;
    }()
  }, {
    key: "renderValidator",
    value: function renderValidator(password, rules) {
      return this.html(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteral(["\n      <div class=\"bm-container\">\n        ", "\n        ", "\n      </div>\n    "])), this.i18n('password.validation.rulesSubtitle'), this._renderRules(password, rules));
    }
  }, {
    key: "_renderRules",
    value: function _renderRules(password, rules) {
      var _this2 = this;
      var allPass = password === '' ? false : this.reduceRulesSync(rules.rules, password);
      if (password !== '') {
        if (allPass) {
          this.reduceRulesAsync(rules.rulesAsync, password).then(function (asyncValid) {
            return _this2.dispatchEvent(new CustomEvent(asyncValid ? 'valid' : 'invalid'));
          });
        } else {
          this.dispatchEvent(new CustomEvent('invalid'));
        }
      }
      return this.html(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteral(["\n<ul>\n  ", "\n</ul>\n<div>", ":</div>\n<ul>\n  ", "\n</ul>\n    "])), repeat(rules.rules, function (i) {
        return i;
      }, function (rule) {
        return until(_this2.renderRule(rule, rule.test(password)));
      }), this.i18n('password.validation.rulesAnd'), repeat(rules.rulesAsync, function (i) {
        return i;
      }, function (rule) {
        return until(_this2.renderRule(rule, allPass ? rule.test(password) : false));
      }));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-settings-password-validation';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        password: {
          type: String,
          attribute: false,
          reflect: false
        },
        rules: {
          type: Object,
          attribute: false,
          reflect: false
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, formStyle, style$4];
    }
  }]);
  return BmSettingsPasswordValidation;
}(i18nMixin(BlueElement));
var registerPasswordValidation = function registerPasswordValidation() {
  registerLanguage$5();
  register$1(BmSettingsPasswordValidation);
};

var _templateObject$3, _templateObject2$3;
var style$3 = css(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n  :host {\n    display: flex;\n    flex-direction: column;\n    contain: content;\n    font-size: 14px;\n  }\n  :host([hidden]) {\n    display: none;\n  }\n  :host bm-settings-page-layout {\n    width: 100%;\n  }\n\n  :host form label input {\n    max-width: none;\n  }\n\n  :host form {\n    display: flex;\n    justify-content: stretch;\n    flex-direction: row;\n  }\n\n  :host > bm-settings-page-layout > bm-alert {\n    margin-bottom: 5px;\n  }\n\n  :host .capsLockOff {\n    display: none;\n  }\n\n  :host .capsLockOn {\n    font-family: KnowledgeRegular, arial, helvetica, sans-serif;\n    color: #dc0a0a;\n    padding-top: 5px;\n  }\n\n  @media (max-width: 768px) {\n    :host form {\n      flex-direction: column-reverse;\n    }\n\n    :host bm-settings-password-validation {\n      margin-bottom: 10px;\n    }\n\n    :host form label {\n      margin-right: 0;\n    }\n  }\n\n  :host .form-field {\n    display: block;\n    flex-grow: 2;\n    flex-shrink: 0;\n  }\n\n  :host bm-settings-password-validation {\n    margin-left: 23px;\n    width: 400px;\n    font-size:16px;\n    font-family: KnowledgeRegular;\n    opacity:1;\n    border-radius:0\n    position:obsolute;\n    padding:0;\n    border:0 5px 10px rgba(0,0,0,0.3);\n    background-color: #fff;\n    text-transform: none;\n    letter-spacing:normal;\n    display: block;\n  }\n\n  :host([onbalance]) bm-settings-password-validation {\n    font-family: KnowledgeLight;\n  }\n\n  :host .current-password-title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  :host .ok {\n    /*\n      This is because ShadyCSS has problems with specificity\n      TODO: Remove when all supported browser have ShadowDOM\n    */\n    color: #090 !important;\n    font-family: Arial, 'Helvetica Neue', sans-serif;\n    font-size: 1em;\n    line-height: 1.42857143;\n    display: flex;\n    align-items: center;\n  }\n  :host .ok:not([visible]) {\n    display: none;\n  }\n  :host .ok::before {\n    content: '\\2714';\n    padding-right: 6px;\n  }\n\n  :host .validation-error::before {\n    content: '\\2718';\n    padding-right: 6px;\n  }\n"], ["\n  :host {\n    display: flex;\n    flex-direction: column;\n    contain: content;\n    font-size: 14px;\n  }\n  :host([hidden]) {\n    display: none;\n  }\n  :host bm-settings-page-layout {\n    width: 100%;\n  }\n\n  :host form label input {\n    max-width: none;\n  }\n\n  :host form {\n    display: flex;\n    justify-content: stretch;\n    flex-direction: row;\n  }\n\n  :host > bm-settings-page-layout > bm-alert {\n    margin-bottom: 5px;\n  }\n\n  :host .capsLockOff {\n    display: none;\n  }\n\n  :host .capsLockOn {\n    font-family: KnowledgeRegular, arial, helvetica, sans-serif;\n    color: #dc0a0a;\n    padding-top: 5px;\n  }\n\n  @media (max-width: 768px) {\n    :host form {\n      flex-direction: column-reverse;\n    }\n\n    :host bm-settings-password-validation {\n      margin-bottom: 10px;\n    }\n\n    :host form label {\n      margin-right: 0;\n    }\n  }\n\n  :host .form-field {\n    display: block;\n    flex-grow: 2;\n    flex-shrink: 0;\n  }\n\n  :host bm-settings-password-validation {\n    margin-left: 23px;\n    width: 400px;\n    font-size:16px;\n    font-family: KnowledgeRegular;\n    opacity:1;\n    border-radius:0\n    position:obsolute;\n    padding:0;\n    border:0 5px 10px rgba(0,0,0,0.3);\n    background-color: #fff;\n    text-transform: none;\n    letter-spacing:normal;\n    display: block;\n  }\n\n  :host([onbalance]) bm-settings-password-validation {\n    font-family: KnowledgeLight;\n  }\n\n  :host .current-password-title {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  :host .ok {\n    /*\n      This is because ShadyCSS has problems with specificity\n      TODO: Remove when all supported browser have ShadowDOM\n    */\n    color: #090 !important;\n    font-family: Arial, 'Helvetica Neue', sans-serif;\n    font-size: 1em;\n    line-height: 1.42857143;\n    display: flex;\n    align-items: center;\n  }\n  :host .ok:not([visible]) {\n    display: none;\n  }\n  :host .ok::before {\n    content: '\\\\2714';\n    padding-right: 6px;\n  }\n\n  :host .validation-error::before {\n    content: '\\\\2718';\n    padding-right: 6px;\n  }\n"])));
var BmSettingsPassword = /*#__PURE__*/function (_alertsMixin) {
  _inherits(BmSettingsPassword, _alertsMixin);
  var _super = _createSuper(BmSettingsPassword);
  function BmSettingsPassword() {
    var _this;
    _classCallCheck(this, BmSettingsPassword);
    _this = _super.call(this);
    _this.email = '';
    _this.password = {
      current: '',
      new: '',
      confirm: ''
    };
    _this.rules = void 0;
    _this.working = false;
    _this.showTyping = false;
    _this.capsLockOn = false;
    _this.newPasswordCorrent = false;
    _this.onKeyDown = _this.onKeyDown.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(BmSettingsPassword, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _yield$Promise$all, _yield$Promise$all2, rules, email;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _get(_getPrototypeOf(BmSettingsPassword.prototype), "connectedCallback", this).call(this);
              _context.prev = 1;
              this.working = true;
              _context.next = 5;
              return _Promise.all([loadPasswordRules(), getMeta().then(function (meta) {
                return meta.EmailAddress;
              })]);
            case 5:
              _yield$Promise$all = _context.sent;
              _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
              rules = _yield$Promise$all2[0];
              email = _yield$Promise$all2[1];
              this.rules = rules;
              this.email = email;
              _context.next = 16;
              break;
            case 13:
              _context.prev = 13;
              _context.t0 = _context["catch"](1);
              this.replaceAlerts(normalizeError(_context.t0), 'danger');
            case 16:
              _context.prev = 16;
              this.working = false;
              return _context.finish(16);
            case 19:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 13, 16, 19]]);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "updated",
    value: function updated(changedProperties) {
      _get(_getPrototypeOf(BmSettingsPassword.prototype), "updated", this).call(this, changedProperties);
      var inputs = _toConsumableArray(this.shadowRoot ? this.shadowRoot.querySelectorAll('form input') : []);
      if (inputs) {
        inputs.forEach(function (el) {
          validForm(el, {
            errorPlacement: 'after'
          });
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var onClick = function onClick() {
        _this2.showTyping = !_this2.showTyping;
      };
      var onInput = function onInput(event) {
        assigner(_this2, 'password', 'new')(event.target.value);
        _this2.onConfirmPasswordInput();
      };
      var buttonText = this.showTyping ? 'password.hideTyping' : 'password.showTyping';
      var isPasswordValid = this.newPasswordCorrent && this.password.confirm !== '' && this.password.new === this.password.confirm;
      return this.html(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n      <bm-settings-page-layout\n        label=\"", "\"\n        @save=\"", "\">\n        <bm-alerts></bm-alerts>\n        <form method=\"post\">\n          <div class=\"form-field\" @keydown=\"", "\">\n            <label>\n              <div class=\"current-password-title\">\n                <span>", " *</span>\n                <button\n                  type=\"button\"\n                  data-qe-id=\"show-typing\"\n                  class=\"bm-button link\"\n                  @click=\"", "\">\n                  ", "\n                </button>\n              </div>\n              <span>\n                <input\n                  class=\"bm-input\"\n                  .value=\"", "\"\n                  required\n                  maxlength=\"50\"\n                  @change=\"", "\"\n                  type=\"", "\">\n              </span>\n            </label>\n            <label>\n              <span>", " *</span>\n              <span>\n                <input\n                  class=\"bm-input\"\n                  name=\"new-password\"\n                  .value=\"", "\"\n                  required\n                  maxlength=\"50\"\n                  @input=\"", "\"\n                  type=\"", "\">\n              </span>\n              <span class=\"ok\" ?visible=\"", "\">\n                ", "\n              </span>\n            </label>\n            <label>\n              <span>", " *</span>\n              <span>\n                <input\n                  class=\"bm-input\"\n                  name=\"confirm-password\"\n                  .value=\"", "\"\n                  required\n                  maxlength=\"50\"\n                  @input=\"", "\"\n                  type=\"", "\">\n              </span>\n              <span class=\"ok\" ?visible=\"", "\">\n                ", "\n              </span>\n            </label>\n            <label>\n              <span>* ", "</span>\n            </label>\n          </div>\n          <bm-settings-password-validation\n            .password=\"", "\"\n            .rules=\"", "\"\n            @invalid=\"", "\"\n            @valid=\"", "\">\n          </bm-settings-password-validation>\n        </form>\n      </bm-settings-page-layout>\n      <div class=\"", "\">\n        ", "\n      </div>\n      <bm-loading ?active=\"", "\"></bm-loading>\n    "])), this.i18n('password.title'), this.onSubmit.bind(this), this.onKeyDown, this.i18n('password.current'), onClick, this.i18n(buttonText), this.password.current, assigner(this, 'password', 'current'), this.showTyping ? 'text' : 'password', this.i18n('password.new'), this.password.new, onInput, this.showTyping ? 'text' : 'password', this.newPasswordCorrent, this.i18n('password.acceptable'), this.i18n('password.confirm'), this.password.confirm, this.onConfirmPasswordInput.bind(this), this.showTyping ? 'text' : 'password', isPasswordValid, this.i18n('password.confirmed'), this.i18n('common.requiredField'), this.password.new, this.rules, this.onPasswordValidity.bind(this, false), this.onPasswordValidity.bind(this, true), this.capsLockOn ? 'capsLockOn' : 'capsLockOff', this.i18n('password.capsLock'), this.working);
    }
  }, {
    key: "onSubmit",
    value: function () {
      var _onSubmit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var formElement, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              this.working = true;
              this.cleanAlerts();
              _context2.prev = 2;
              formElement = this.shadowRoot ? this.shadowRoot.querySelector('form') : null;
              if (!(!formElement || formElement && !formElement.checkValidity())) {
                _context2.next = 6;
                break;
              }
              return _context2.abrupt("return");
            case 6:
              if (!(this.password.new !== this.password.confirm)) {
                _context2.next = 8;
                break;
              }
              return _context2.abrupt("return");
            case 8:
              _context2.next = 10;
              return savePassword(this.password.current, this.password.new);
            case 10:
              response = _context2.sent;
              if (!(response.code === 401)) {
                _context2.next = 14;
                break;
              }
              this.replaceAlerts(instantTranslate('password.invalidCurrentPassword'), 'danger');
              return _context2.abrupt("return");
            case 14:
              if (!(response.code === 400 && response.error === 'PASSWORD_CONTAINS_USERINFO')) {
                _context2.next = 17;
                break;
              }
              this.replaceAlerts(instantTranslate('password.contains.personalInfo'), 'danger');
              return _context2.abrupt("return");
            case 17:
              _context2.t0 = this;
              _context2.next = 20;
              return translate('password.success', {
                val: this.email
              });
            case 20:
              _context2.t1 = _context2.sent;
              _context2.t0.replaceAlerts.call(_context2.t0, _context2.t1, 'success');
              this.password = {
                current: '',
                new: '',
                confirm: ''
              };
              this.newPasswordCorrent = false;
              this.dispatchEvent(new CustomEvent('save', {
                bubbles: true,
                composed: true
              }));
              _context2.next = 30;
              break;
            case 27:
              _context2.prev = 27;
              _context2.t2 = _context2["catch"](2);
              this.replaceAlerts(normalizeError(_context2.t2), 'danger');
            case 30:
              _context2.prev = 30;
              this.working = false;
              return _context2.finish(30);
            case 33:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[2, 27, 30, 33]]);
      }));
      function onSubmit() {
        return _onSubmit.apply(this, arguments);
      }
      return onSubmit;
    }()
  }, {
    key: "onPasswordValidity",
    value: function () {
      var _onPasswordValidity = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(valid) {
        var _this$shadowRoot;
        var target, msg;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              target = ((_this$shadowRoot = this.shadowRoot) !== null && _this$shadowRoot !== void 0 ? _this$shadowRoot : this).querySelector('[name="new-password"]');
              if (!(target && this.password.new && !valid)) {
                _context3.next = 10;
                break;
              }
              _context3.next = 4;
              return translate('password.nonAcceptable');
            case 4:
              msg = _context3.sent;
              target.setAttribute('data-customError', msg);
              target.setCustomValidity(msg);
              this.newPasswordCorrent = false;
              _context3.next = 13;
              break;
            case 10:
              target.setCustomValidity('');
              target.removeAttribute('data-customError');
              this.newPasswordCorrent = true;
            case 13:
              target.checkValidity();
              target.dispatchEvent(new Event('input', {
                bubbles: false
              }));
            case 15:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function onPasswordValidity(_x) {
        return _onPasswordValidity.apply(this, arguments);
      }
      return onPasswordValidity;
    }()
  }, {
    key: "onConfirmPasswordInput",
    value: function () {
      var _onConfirmPasswordInput = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(event) {
        var _this$shadowRoot2;
        var target, msg;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!(event !== null && event !== void 0 && event.detail && event.detail.ignore)) {
                _context4.next = 2;
                break;
              }
              return _context4.abrupt("return");
            case 2:
              target = ((_this$shadowRoot2 = this.shadowRoot) !== null && _this$shadowRoot2 !== void 0 ? _this$shadowRoot2 : this).querySelector('[name="confirm-password"]');
              target.setCustomValidity('');
              target.removeAttribute('data-customError');
              assigner(this, 'password', 'confirm')(target.value);
              if (!(this.password.confirm !== '' && this.password.confirm !== this.password.new)) {
                _context4.next = 12;
                break;
              }
              _context4.next = 9;
              return translate('password.notMatch');
            case 9:
              msg = _context4.sent;
              target.setAttribute('data-customError', msg);
              target.setCustomValidity(msg);
            case 12:
              target.checkValidity();
              target.dispatchEvent(new CustomEvent('input', {
                bubbles: false,
                detail: {
                  ignore: true
                }
              }));
            case 14:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function onConfirmPasswordInput(_x2) {
        return _onConfirmPasswordInput.apply(this, arguments);
      }
      return onConfirmPasswordInput;
    }()
  }, {
    key: "onKeyDown",
    value: function onKeyDown(event) {
      this.capsLockOn = event.getModifierState('CapsLock');
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-settings-password';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        capsLockOn: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        email: {
          type: String,
          attribute: true,
          reflect: true
        },
        newPasswordCorrent: {
          type: Boolean,
          attribute: false,
          reflect: false
        },
        password: {
          type: Object,
          attribute: false,
          reflect: false
        },
        rules: {
          type: Object,
          attribute: false,
          reflect: false
        },
        showTyping: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        working: {
          type: Boolean,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, formStyle, bmButtonStyle, bmInputStyle, style$3];
    }
  }]);
  return BmSettingsPassword;
}(alertsMixin(i18nMixin(BlueElement)));
var registerPassword = function registerPassword() {
  registerLanguage$5();
  registerAlerts();
  registerLoading();
  registerPageLayout();
  registerPasswordValidation();
  register$1(BmSettingsPassword);
};

var _templateObject$2, _templateObject2$2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
var sections = {
  accountInfo: {
    code: 'account-information',
    template: function template(mode, product, profileType) {
      var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
          hideLanguage: false
        },
        hideLanguage = _ref.hideLanguage,
        hideMiddleName = _ref.hideMiddleName;
      return html(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n        <bm-settings-account-information\n          mode=\"", "\"\n          product=\"", "\"\n          profileType=", "\n          ?hideLanguage=\"", "\"\n          ?hideMiddleName=\"", "\"\n        ></bm-settings-account-information>\n      "])), mode, product, profileType, hideLanguage, hideMiddleName);
    }
  },
  linkedAccounts: {
    code: 'linked-accounts',
    template: function template(mode, product) {
      return html(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral([" <bm-settings-linked-accounts product=\"", "\" mode=\"", "\"></bm-settings-linked-accounts> "])), product, mode);
    }
  },
  mfa: {
    code: 'mfa',
    template: function template(mode) {
      return html(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([" <bm-settings-mfa mode=\"", "\"></bm-settings-mfa> "])), mode);
    }
  },
  onvioCenter: {
    code: 'onvio-center',
    template: function template(mode) {
      return html(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([" <bm-settings-onvio-center mode=\"", "\"></bm-settings-onvio-center> "])), mode);
    }
  },
  password: {
    code: 'password',
    template: function template(mode) {
      return html(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([" <bm-settings-password mode=\"", "\"></bm-settings-password> "])), mode);
    }
  },
  timeAndBilling: {
    code: 'time-and-billing',
    template: function template(mode) {
      return html(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([" <bm-settings-time-and-billing mode=\"", "\"></bm-settings-time-and-billing> "])), mode);
    }
  }
};
function getSectionByCode(code, mode, product, profileType) {
  var _context;
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
    hideLanguage: false
  };
  var section = _findInstanceProperty(_context = _Object$entries(sections)).call(_context, function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2);
      _ref3[0];
      var value = _ref3[1];
    return value.code === code;
  });
  return section ? section[1].template(mode, product, profileType, options) : null;
}
var style$2 = css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  :host {\n    display: flex;\n    contain: content;\n    font-size: 14px;\n  }\n  :host([hidden]) {\n    display: none;\n  }\n  :host bm-settings-menu {\n    flex-shrink: 0;\n  }\n\n  :host .content {\n    flex-grow: 1;\n  }\n\n  :host .content > * {\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n"])));
var BmSettingsScreen = /*#__PURE__*/function (_BlueElement) {
  _inherits(BmSettingsScreen, _BlueElement);
  var _super = _createSuper(BmSettingsScreen);
  function BmSettingsScreen() {
    var _this;
    _classCallCheck(this, BmSettingsScreen);
    _this = _super.call(this);
    _this.section = void 0;
    _this.mode = void 0;
    _this.product = void 0;
    _this.language = getCurrentLanguage();
    _this.hideLanguage = false;
    _this.hideMiddleName = false;
    _this.profileType = 'auth0';
    _this.section = sections.accountInfo.code;
    changeLanguage(_this.language);
    return _this;
  }
  _createClass(BmSettingsScreen, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _get(_getPrototypeOf(BmSettingsScreen.prototype), "connectedCallback", this).call(this);
              _context2.next = 3;
              return not('Platform_DisableAuth0Phase2');
            case 3:
              if (!_context2.sent) {
                _context2.next = 7;
                break;
              }
              _context2.t0 = 'auth0';
              _context2.next = 8;
              break;
            case 7:
              _context2.t0 = 'standard';
            case 8:
              this.profileType = _context2.t0;
            case 9:
            case "end":
              return _context2.stop();
          }
        }, _callee, this);
      }));
      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }
      return connectedCallback;
    }()
  }, {
    key: "render",
    value: function render() {
      var options = {
        hideLanguage: this.hideLanguage,
        hideMiddleName: this.hideMiddleName
      };
      return this.html(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n      <bm-settings-menu\n        active=\"", "\"\n        @active-change=\"", "\">\n      </bm-settings-menu>\n      <div class=\"content\">\n        ", "\n      </div>\n    "])), this.section, this.onMenuChange.bind(this), getSectionByCode(this.section, this.mode, this.product, this.profileType, options));
    }
  }, {
    key: "onMenuChange",
    value: function onMenuChange(event) {
      this.section = event.detail;
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-settings-screen';
    }
  }, {
    key: "properties",
    get: function get() {
      return {
        language: {
          type: String,
          attribute: true,
          reflect: true
        },
        section: {
          type: String,
          attribute: true,
          reflect: true
        },
        mode: {
          type: String,
          attribute: true,
          reflect: true
        },
        hideLanguage: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        hideMiddleName: {
          type: Boolean,
          attribute: true,
          reflect: true
        },
        product: {
          type: String,
          attribute: true,
          reflect: true
        }
      };
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, style$2];
    }
  }]);
  return BmSettingsScreen;
}(BlueElement);
var registerScreen = function registerScreen() {
  registerAccountInformation();
  registerLinkedAccounts();
  registerMenu();
  registerMFA();
  registerPassword();
  register$1(BmSettingsScreen);
};

var _templateObject$1, _templateObject2$1;
var style$1 = css(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n  :host {\n    display: flex;\n    contain: content;\n    font-size: 14px;\n  }\n  :host([hidden]) {\n    display: none;\n  }\n"])));
var BmSettingsTimeAndBilling = /*#__PURE__*/function (_i18nMixin) {
  _inherits(BmSettingsTimeAndBilling, _i18nMixin);
  var _super = _createSuper(BmSettingsTimeAndBilling);
  function BmSettingsTimeAndBilling() {
    _classCallCheck(this, BmSettingsTimeAndBilling);
    return _super.apply(this, arguments);
  }
  _createClass(BmSettingsTimeAndBilling, [{
    key: "render",
    value: function render() {
      return this.html(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral([""])));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-settings-time-and-billing';
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, style$1];
    }
  }]);
  return BmSettingsTimeAndBilling;
}(i18nMixin(BlueElement));
var registerTimeAndBilling = function registerTimeAndBilling() {
  return register$1(BmSettingsTimeAndBilling);
};

var _templateObject, _templateObject2;
var style = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  :host {\n    display: flex;\n    contain: content;\n    font-size: 14px;\n  }\n  :host([hidden]) {\n    display: none;\n  }\n"])));
var BmSettingsOnvioCenter = /*#__PURE__*/function (_i18nMixin) {
  _inherits(BmSettingsOnvioCenter, _i18nMixin);
  var _super = _createSuper(BmSettingsOnvioCenter);
  function BmSettingsOnvioCenter() {
    _classCallCheck(this, BmSettingsOnvioCenter);
    return _super.apply(this, arguments);
  }
  _createClass(BmSettingsOnvioCenter, [{
    key: "render",
    value: function render() {
      return this.html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    "])));
    }
  }], [{
    key: "is",
    get: function get() {
      return 'bm-settings-onvio-center';
    }
  }, {
    key: "styles",
    get: function get() {
      return [shadowDOMPolyfillContainingBlockFix, style];
    }
  }]);
  return BmSettingsOnvioCenter;
}(i18nMixin(BlueElement));
var registerOnvioCenter = function registerOnvioCenter() {
  return register$1(BmSettingsOnvioCenter);
};

var version = "10.4.5";
var name = "@onviobr/profile-screen";
registerLibrary({
  version: version,
  name: name
});
var register = function register() {
  registerAccountInformation();
  registerLinkedAccounts();
  registerAccountSelector();
  registerMenu();
  registerMFA();
  registerPassword();
  registerScreen();
};

export { BmLinkedAccountDetail, BmLinkedAccountSelector, BmSettingsAccountInformation, BmSettingsLinkedAccounts, BmSettingsLinkedAccountsEdit, BmSettingsMFA, BmSettingsMenu, BmSettingsOnvioCenter, BmSettingsPassword, BmSettingsPasswordCheck, BmSettingsPasswordValidation, BmSettingsScreen, BmSettingsTerms, BmSettingsTimeAndBilling, checkPassword, editAccount, openLinkedAccountModal, products, register, registerAccountDetail, registerAccountInformation, registerAccountSelector, registerLinkedAccounts, registerLinkedAccountsEdit, registerMFA, registerMenu, registerOnvioCenter, registerPassword, registerPasswordCheck, registerPasswordValidation, registerScreen, registerTerms, registerTimeAndBilling, showTermsAndConditions };
